// AUTO-STRUCTURED locale file. Keys mirror en.ts exactly; missing keys fall back
// to English (see src/i18n/index.ts). Placeholders use {name} interpolation.
export default {
 modelAuthorization: {
  "title": "ChatGPT 연결",
  "description": "ChatGPT 계정으로 개인 클라우드 작업을 실행합니다.",
  "name": "연결 이름",
  "enterCode": "ChatGPT 인증 페이지에 다음 코드를 입력하세요:",
  "openProvider": "ChatGPT 인증 페이지 열기",
  "enableDevice": "ChatGPT 보안 설정에서 기기 코드 로그인을 활성화하세요. 인증을 완료하면 이 페이지에서 결과를 자동으로 확인합니다.",
  "chooseModels": "연결되었습니다. 이 창을 닫고 실시간 모델 목록에서 사용할 모델을 선택하세요.",
  "cancel": "인증 취소",
  "retry": "다시 확인",
  "reauthorize": "다시 인증",
  "done": "완료",
  "connect": "ChatGPT 연결",
  "failed": "인증에 실패했습니다. 다시 시도하세요.",
  "state": {
    "pending": "인증 대기 중",
    "ready": "연결됨",
    "expired": "인증 코드가 만료되었습니다. 다시 시작하세요.",
    "requires_reauth": "인증 필요"
  }
},
  cloudRemoteInspector: {
    noModels: "이 기기에 사용 가능한 모델이 없습니다. 기기에서 제공자를 설정하거나 개인 클라우드 모델을 추가하세요.",
    modelSettings: "모델 설정",
    fullPreview: "대상 브랜치 기준으로 커밋된 변경과 커밋하지 않은 변경을 모두 표시합니다. 선택한 파일만 게시됩니다。",
    "createDraft": "초안 Pull request 만들기",
    "deliveryUpgrade": "검토한 변경 사항을 게시하려면 기기의 jcode를 업데이트하세요.",
    "close": "닫기",
    "delivering": "게시 중…",
    "publishDraft": "브랜치 푸시 및 초안 만들기",
    "delivered": "초안 Pull request를 만들었습니다.",
    "openPR": "Pull request 열기",
    "deliveryExplanation": "검토한 파일을 선택하세요. 기기의 Git 및 GitHub CLI 인증 정보로 별도 브랜치를 푸시합니다. 현재 브랜치, 파일, 스테이징 영역은 유지됩니다.",
    "defaultBase": "대상: 저장소 기본 브랜치",
    "prTitle": "Pull request 제목",
    "prBody": "설명 (선택 사항)",
    "selectFiles": "게시할 파일 선택",
    "viewPatch": "패치 검토",

    "title": "작업 정보",
    "changes": "변경 사항",
    "details": "상세 정보",
    "upgradeRequired": "작업 공간의 변경 사항을 확인하려면 기기의 jcode를 업데이트하세요.",
    "setup": "기기 연결 안내",
    "files": "파일 {count}개",
    "refresh": "새로고침",
    "offline": "기기가 오프라인입니다. 다시 연결한 후 변경 사항을 새로고침하세요.",
    "workspaceChanges": "HEAD 기준 현재 작업 공간 변경 사항입니다. 이 작업 이전의 변경도 포함됩니다.",
    "clean": "커밋하지 않은 변경 사항이 없습니다.",
    "truncated": "표시 제한을 초과하여 미리보기가 완전하지 않습니다. 기기에서 전체 변경 사항을 확인하세요.",
    "updated": "{time} 업데이트",
    "device": "기기",
    "workspace": "작업 공간",
    "branch": "브랜치",
    "model": "모델",
    "connection": "연결 상태",
    "online": "온라인",
    "offlineLabel": "오프라인",
    "version": "jcode 버전",
    "openDevice": "기기 열기",
    "binary": "바이너리 파일입니다. 기기에서 내용을 확인하세요."
},
  cloudRefresh: {
    "noGitProviders": "Git 로그인 공급자가 설정되지 않았습니다. 관리자에게 공급자 연결 설정을 요청하세요.",
    "sessionNotFound": "세션을 찾을 수 없습니다",
    "addAttachments": "파일 추가",
    "uploading": "업로드 중…",
    "attachmentReady": "첨부됨",
    "attachmentExpired": "만료됨 — 다시 업로드하세요",
    "uploadFailed": "업로드하지 못했습니다. 다시 시도하거나 파일을 제거하세요. 저장소를 사용할 수 없으면 관리자에게 문의하세요.",
    "attachmentLimits": "최대 10개 파일, 파일당 25 MiB, 총 100 MiB. 빈 파일은 지원하지 않습니다.",
    "removeAttachment": "{name} 제거",

    "navigationFailed": "최근 작업을 불러오지 못했습니다.",
    "accountRequired": "개인 계정으로 로그인하여 설정을 관리하세요.",
    "noMatchingDevices": "일치하는 기기가 없습니다",
    "personalModelsEmpty": "위에서 개인 공급자를 추가하거나 관리자에게 모델 사용 권한을 요청하세요.",

    "personalModelsDescription": "개인 모델은 접근 가능한 모든 저장소에서 사용할 수 있습니다.",
    "updateCredentials": "인증 정보 갱신",
    "enable": "활성화",
    "disable": "비활성화",
    "deleteModel": "{name} 삭제",
    "deleteModelConfirm": "{name} 모델을 삭제할까요?",
    "availableModels": "작업에 사용 가능한 모델",

    "defaultModel": "기본 모델",
    "automaticModel": "사용 가능한 모델 자동 선택",
    "unavailableModel": "모델을 사용할 수 없습니다. 다른 모델을 선택하세요",
    "defaultPermission": "기본 실행 권한",
    "askApproval": "승인 요청",
    "fullAccess": "전체 접근",
    "planMode": "계획만 작성",
    "defaultEffort": "기본 추론 수준",
    "effort_auto": "자동",
    "effort_low": "낮음",
    "effort_medium": "중간",
    "effort_high": "높음",
    "light": "라이트",
    "dark": "다크",
    "sendKey": "메시지 전송 방식",

    "recentRepositories": "최근 저장소",
    "remoteDevices": "원격 기기",
    "recentConversations": "최근 대화",
    "allRepositories": "모든 저장소",
    "personalWorkspace": "개인 작업 공간",
    "homeTitle": "다음에는 무엇을 할까요?",
    "homeDescription": "아이디어부터 시작하세요. jcode가 작업을 도와드립니다.",
    "searchTasks": "작업 검색",
    "all": "전체",
    "active": "진행 중",
    "attention": "확인 필요",
    "completed": "완료",
    "noMatch": "일치하는 작업이 없습니다",
    "noMatchDescription": "다른 검색어를 입력하거나 필터를 초기화하세요.",
    "clearFilters": "필터 초기화",
    "connectDevice": "기기 연결",
    "searchDevices": "기기 검색",
    "devicesTitle": "기기에서 작업을 이어가세요",
    "devicesDescription": "jcode에 로그인한 기기에서 작업 공간을 여세요.",
    "noDevices": "연결된 기기가 없습니다",
    "noDevicesDescription": "기기의 jcode를 연결하여 원격 작업을 시작하세요.",
    "backDevices": "기기 목록으로 돌아가기",
    "startRemote": "원격 작업 시작",
    "recentSessions": "최근 세션",
    "deviceNotFound": "기기를 찾을 수 없습니다",
    "deviceUnavailable": "기기를 사용할 수 없거나 접근 권한이 없습니다.",
    "encryptedSession": "암호화된 세션",
    "pairToRead": "이 브라우저를 페어링하면 대화를 볼 수 있습니다."
},
  cloudDeviceGuide: {
    installHint: '원격 작업 공간 기능을 사용하려면 이 기기에 최신 jcode를 설치하세요.',
    download: 'jcode 다운로드 또는 업데이트',
    "secure": "종단 간 암호화 연결",
    "section": "원격 연결",
    "title": "jcode 기기 연결",
    "description": "로그인하고 기기를 승인한 다음 이 브라우저를 페어링하여 암호화된 작업 공간과 대화를 여세요.",
    "steps": "원격 연결 단계",
    "login": "jcode 로그인",
    "approve": "기기 승인",
    "pair": "암호화 페어링",
    "newDevice": "새 원격 기기",
    "minute": "약 1분",
    "runCommand": "로그인 명령 실행",
    "getCode": "일회용 기기 코드 받기",
    "confirmIdentity": "기기 확인",
    "approveAccount": "계정 접근 승인",
    "completePair": "페어링 완료",
    "approveLocal": "로컬 jcode에서 승인",
    "onDevice": "연결할 기기에서",
    "runLogin": "jcode login 실행",
    "commandDescription": "명령은 일회용 인증 코드를 생성하고 브라우저를 자동으로 엽니다. 열리지 않으면 아래에 코드를 입력하세요.",
    "terminal": "터미널",
    "copyCommand": "로그인 명령 복사",
    "copyError": "복사하지 못했습니다. 위 명령을 선택하여 직접 복사하세요.",
    "enterCode": "CLI에 표시된 코드 입력",
    "continue": "인증 계속",
    "ciphertext": "Cloud는 암호문만 전달합니다",
    "ciphertextDescription": "기기 코드는 로그인을 계정에 연결합니다. 페어링 키는 jcode와 이 브라우저에 보관되며 서버는 대화 내용을 읽을 수 없습니다.",
    "connected": "연결된 기기",
    "connectedDescription": "기기 작업 공간을 열거나 위 단계에 따라 다른 기기를 추가하세요.",
    "expires": "인증 코드의 만료 시간은 jcode에 표시됩니다."
},
  common: {
    ok: '확인',
    add: '추가',
    back: '뒤로',
    cancel: '취소',
    close: '닫기',
    save: '저장',
    saving: '저장 중…',
    saved: '저장됨',
    delete: '삭제',
    remove: '제거',
    edit: '편집',
    rename: '이름 변경',
    retry: '재시도',
    loading: '불러오는 중…',
    enable: '활성화',
    disable: '비활성화',
    search: '검색',
    done: '완료',
    other: '기타',
    details: '상세',
    connected: '연결됨',
    disconnected: '연결 끊김',
    configured: '설정됨',
    notConfigured: '미설정',
    recommended: '추천',
    copy: '복사',
    copied: '복사됨',
    dismiss: '닫기',
    create: '만들기',
    creating: '만드는 중…',
    confirm: '확인',
    continue: '계속',
  },

  language: {
    label: '언어',
  },

  format: {
    justNow: '방금',
    minutesAgo: '{n}분 전',
    hoursAgo: '{n}시간 전',
    daysAgo: '{n}일 전',
    durationSeconds: '{n}초',
    durationMinutes: '{m}분',
    durationMinutesSeconds: '{m}분 {s}초',
    durationHoursMinutes: '{h}시간 {m}분',
  },

  run: {
    permissionArgumentsUnavailable: '이 이전 승인 요청에는 실제 인수가 기록되지 않았습니다.',
    thinking: '생각 중',
    thinkingAria: '생각 중…',
    projectMember: '리포지토리 멤버',
    toolStatusDone: '완료',
    tool: {
      read: '프로젝트 컨텍스트 읽기',
      edit: '파일 편집',
      execute: '명령 실행',
      search: '워크스페이스 검색',
    },
    toolStatus: {
      running: '실행 중',
      failed: '실패',
      queued: '대기 중',
      canceled: '취소됨',
    },
    statusName: {
      queued: '대기 중',
      running: '실행 중',
      succeeded: '성공',
      failed: '실패',
      canceled: '취소됨',
      scheduling: '스케줄링 중',
      awaiting_input: '입력 대기 중',
      blocked: '차단됨',
    },
    unknownStatus: '알 수 없음',
    finalStatus: '최종 상태: {status}',
    status: '상태: {status}',
    artifactReady: '아티팩트 준비됨: {artifact}',
    pushedAt: '{branch}을(를) {sha}에 푸시함',
    pushed: '{branch}을(를) 푸시함',
    result: {
      noChanges: '코드 변경 없음',
      generic: '결과',
    },
    session: {
      resumed: '세션 재개됨',
      established: '세션 수립됨',
      finished: '세션 종료됨',
      finishedIdle: '세션 종료됨 (유휴 시간 초과)',
    },
    permissionTimedOut: '권한 요청 시간 초과',
    permissionResolved: '권한 처리됨',
    unknownEvent: '알 수 없는 이벤트: {type}',
    toolStarted: '{tool} 시작됨',
    toolFailed: '{tool} 실패함',
    toolCompleted: '{tool} 완료됨',
    permission: {
      label: '권한',
      required: '권한 필요',
      noAction: '작업 없음 (취소됨)',
      timedOut: '시간 초과',
      resolved: '처리됨',
      answered: '응답함 — 에이전트를 기다리는 중…',
      readonly: '읽기 전용 — 리포지토리 멤버가 응답할 수 있습니다.',
    },
  },

  workspace: {
    provider: {
      pathOrUrl: '경로 / 원격 URL',
      gitRepository: 'Git 리포지토리',
    },
    runKind: {
      review: '리뷰',
      prEvent: 'PR 이벤트',
      schedule: '예약',
      kanban: 'Kanban',
      webhook: 'Webhook',
      session: '세션',
      task: '작업',
    },
  },

  shell: {
    skipToContent: '콘텐츠로 건너뛰기',
    globalNav: '전역 내비게이션',
    primaryNav: '기본',
    workspaceEyebrow: '워크스페이스',
    adminEyebrow: '관리',
    clusterTitle: 'Cluster',
    cloudTitle: 'jcode Cloud',
    clusterSubtitle: 'Cluster 구성',
    cloudSubtitle: '셀프 호스팅 코딩 워크스페이스',
    projects: '프로젝트',
    cluster: 'Cluster',
    devices: '기기',
    clusterSections: 'Cluster 섹션',
    adminBadge: '관리자',
    recentProjects: '최근 Repositories',
    recentEmpty: '열어 본 Repository가 여기에 바로가기로 표시됩니다.',
    recentAria: '최근 Repositories',
    workspaceAria: 'jcode Cloud 워크스페이스',
    demoEnv: '데모 / 로컬',
    orchestratorEnv: '오케스트레이터',
    demoTag: 'DEMO',
    switchToLight: '라이트 모드로 전환',
    switchToDark: '다크 모드로 전환',
    services_one: '{count}개 서비스',
    services_other: '{count}개 서비스',
    crumbProjects: '프로젝트',
    crumbNewProject: '새 프로젝트',
    crumbCluster: 'Cluster',
    crumbModels: '모델',
    crumbConnections: '연결',
    crumbOverview: '개요',
    crumbWorkspace: '워크스페이스',
    crumbProject: '프로젝트',
    crumbDevice: '디바이스',
    crumbSession: '세션',
    crumbNotFound: '찾을 수 없음',
  },

  cluster: {
    accessDenied: {
      roleCode: '역할 / 프로젝트 관리자',
      title: 'Cluster는 이 역할의 범위 밖입니다.',
      body: '이 역할은 리포지토리만 관리합니다. 용량, 모델 자격 증명, 가드레일, 제공자 구성은 Cluster 관리자가 필요합니다.',
      noticeTitle: 'Cluster 내비게이션은 의도적으로 숨겨져 있습니다.',
      noticeBody: '이 직접 경로는 시스템 스냅샷 요청을 보내지 않고 경계를 설명합니다.',
      backToProjects: '리포지토리로 돌아가기',
    },
    overview: {
      loadingSnapshot: 'Cluster 스냅샷 불러오는 중…',
      snapshotLoadError: 'Cluster 스냅샷을 불러올 수 없습니다',
      eyebrow: '오케스트레이터 스냅샷',
      title: 'Cluster',
      description: '이 오케스트레이터의 용량, 가드레일, 런타임 연결 구성. 편집 가능한 구성은 해당 소유 섹션에 남아 있습니다.',
      metaNamespace: '네임스페이스 / {value}',
      metaLauncher: '런처 / {value}',
      metaCommit: '커밋 / {value}',
      snapshotLoaded: '스냅샷 불러옴',
      refresh: '새로고침',
      capacitySummaryAria: '실행 용량 요약',
      metricRunning: '실행 중',
      metricRunningNote: '현재 활성',
      metricScheduling: '스케줄링 중',
      metricSchedulingNote: '파드 대기 중',
      metricQueued: '대기 중',
      metricQueuedNote: '용량 대기 중',
      metricMax: '최대',
      metricMaxNote: '동시 실행',
      capacityTitle: '용량',
      capacityAside: '{active} 활성 / 최대 {max}',
      concurrencyUncapped: '동시 실행 수에 제한이 없습니다',
      concurrencyInUse: '설정된 동시 실행 수 사용 중',
      unlimitedSlots: '무제한 슬롯',
      slotsAvailable: '{count}개 슬롯 사용 가능',
      legendRunning: '{count}개 실행 중',
      legendScheduling: '{count}개 스케줄링 중',
      gitPolicyTitle: 'Git 제공자 정책',
      giteaEnabled: 'Gitea 활성화됨',
      giteaDisabled: 'Gitea 비활성화됨',
      giteaUrlLabel: 'Gitea URL',
      draftPrLabel: '초안 PR 출력',
      draftPrAvailable: '권한이 부여된 ID에 사용 가능',
      draftPrUnavailable: '사용 불가 — diff만',
      allowedHostsLabel: '허용된 Git 호스트',
      unrestricted: '제한 없음',
      modelsConfigured_one: '{count}개 카탈로그 모델이 설정되어 있습니다.',
      modelsConfigured_other: '{count}개 카탈로그 모델이 설정되어 있습니다.',
      modelsManagedPrefix: '모델 자격 증명과 계정 액세스는 ',
      modelsLink: '모델',
      modelsManagedSuffix: ' 페이지에서 관리되며, 계정과 리포지토리는 제공자 키를 받지 않습니다.',
      guardrailsTitle: '가드레일',
      runTimeoutLabel: '실행 시간 제한',
      jobTtlLabel: 'Job TTL',
      runnerTitle: '러너',
      imageLabel: '이미지',
      launcherLabel: '런처',
      workspaceLabel: '워크스페이스',
      persistent: '영구',
      ephemeral: '임시',
      prewarmLabel: '이미지 사전 다운로드',
      prewarmUnsupported: 'Kubernetes 런처가 필요합니다',
      prewarmNever: '동기화된 적 없음',
      prewarmReady: '{ready}/{desired} 노드에 캐시됨',
      prewarmLastSyncLabel: '마지막 동기화',
      prewarmSync: '최신 이미지 동기화',
      prewarmSyncError: '동기화 실패 — orchestrator 로그를 확인하세요',
      buildTitle: '빌드',
      versionLabel: '버전',
      commitLabel: '커밋',
      usersLabel: '사용자',
      coldArchiveUnavailable: '콜드 아카이브를 사용할 수 없습니다.',
    },
    models: {
      contextUnknown: '컨텍스트 알 수 없음',
      contextK: '{value}K 컨텍스트',
      context: '{value} 컨텍스트',
      eyebrow: 'Cluster 카탈로그',
      title: '모델 제공자',
      description: '제공자를 한 번 연결하고 자격 증명을 봉인한 뒤 모델 액세스를 계정에 직접 부여하세요.',
      addProvider: '제공자 추가',
      securityNote: '제공자 키는 쓰기 전용입니다. 카탈로그는 자격 증명 설정 여부만 보고하며, 저장된 값은 어떤 부분도 표시하지 않습니다.',
      filterLabel: '모델 또는 제공자 필터링',
      filterPlaceholder: '모델 또는 제공자 필터링…',
      resultCount: '/ 총 {total}개 모델',
      configuredProviders: '설정된 제공자',
      providersSummary: '{providers}개 제공자 · {accountGrants}개 계정 권한',
      loadingProviders: '모델 제공자 불러오는 중…',
      loadProvidersError: '모델 제공자를 불러올 수 없습니다',
      noMatches: '일치하는 모델 또는 제공자가 없습니다.',
      noProviders: '설정된 모델 제공자가 없습니다.',
      noMatchesHint: '제공자 이름, 모델 ID 또는 기능으로 검색해 보세요.',
      noProvidersHint: 'Desktop과 리포지토리 실행에서 계정이 모델을 사용할 수 있도록 제공자를 추가하세요.',
      authServiceIdentity: '서비스 ID',
      authKeySet: '키 설정됨',
      authKeyless: '키 없음',
      authKeyMissing: '키 누락',
      verifiedIn: '{ms}ms 만에 제공자를 검증했습니다.',
      reachableIn: '{ms}ms 만에 제공자에 도달했습니다. 카탈로그를 사용할 수 없습니다.',
      verifyError: '제공자를 검증할 수 없습니다.',
      removeConfirm: '{name} 및 설정된 모든 모델을 제거하시겠습니까?',
      providerRemoved: '제공자가 제거되었습니다.',
      removeError: '제공자를 제거할 수 없습니다.',
      customLabel: '커스텀',
      credKeylessIdentity: '키 없는 워크로드 ID',
      credConfigured: '자격 증명 설정됨',
      credNoneRequired: '자격 증명 불필요',
      credRequired: '자격 증명 필요',
      lastTest: '마지막 테스트: {error}',
      verified: '검증됨',
      test: '테스트',
      editProviderAria: '{name} 제공자 편집',
      removeProviderAria: '{name} 제공자 제거',
      customModel: '커스텀 모델',
      configuredModel: '설정된 모델',
      configuredModels: '설정된 모델',
      catalogUnavailable: '카탈로그 사용 불가',
      browseCatalog: '카탈로그 탐색',
      customModelAction: '커스텀 모델',
      limitNote: '이 엔드포인트는 모델 카탈로그를 제공하지 않습니다. 모델을 명시적으로 추가해야 하며, 대체 카탈로그가 제공되지 않습니다.',
      capabilitiesAria: '모델 기능',
      capReasoning: '추론',
      capTools: '도구',
      capImage: '이미지',
      projectGrants_one: '프로젝트 권한 부여',
      projectGrants_other: '프로젝트 권한 부여',
      accountGrants_one: '계정 권한 부여',
      accountGrants_other: '계정 권한 부여',
      manageAccess: '액세스 관리',
      capabilitiesLegend: '기능',
      capToolUse: '도구 사용',
      capImageInput: '이미지 입력',
      customValidationRequired: '표시 이름과 모델 ID는 필수입니다.',
      customValidationContext: '컨텍스트 창은 0 또는 양수여야 합니다.',
      customAdded: '커스텀 모델이 추가되었습니다.',
      addModelError: '모델을 추가할 수 없습니다.',
      customDialogTitle: '커스텀 모델 · {name}',
      addCustomModel: '커스텀 모델 추가',
      displayNameLabel: '표시 이름',
      displayNamePlaceholder: '예: Coding Plan',
      modelIdLabel: '모델 ID',
      modelIdHint: '업스트림 모델 ID만 입력하세요. 런타임 제공자 접두사는 서버 측에서 추가됩니다.',
      contextWindowLabel: '컨텍스트 창',
      modelAdded: '{name}이(가) 추가되었습니다.',
      addCatalogError: '카탈로그 모델을 추가할 수 없습니다.',
      syncMetadata: '메타데이터 동기화',
      metadataSynced: '{name} 메타데이터가 동기화되었습니다.',
      syncMetadataError: '모델 메타데이터를 동기화할 수 없습니다.',
      catalogDialogTitle: '카탈로그 · {name}',
      loadingCatalog: '제공자 카탈로그 불러오는 중…',
      catalogLoadError: '카탈로그를 불러올 수 없습니다',
      catalogLoadFallback: '제공자 카탈로그를 불러올 수 없습니다.',
      grantUpdateError: '프로젝트 권한 부여를 업데이트할 수 없습니다.',
      accountGrantUpdateError: '계정 액세스를 업데이트할 수 없습니다.',
      accessDialogTitle: '모델 액세스 · {name}',
      accessIntro: '계정에 한 번 권한을 부여해 Cloud와 Desktop 모두에서 사용합니다. 자격 증명은 Cluster 경계 안에 유지됩니다.',
      accessTabsAria: '모델 액세스 범위',
      accessAccounts: '계정',
      accessProjects: '프로젝트',
      accountAccessIntro: '권한을 받은 계정의 Repository 실행과 모든 Desktop이 이 모델을 사용할 수 있습니다.',
      projectAccessIntro: '권한을 받은 프로젝트는 Cloud 실행에서 이 모델을 선택할 수 있습니다.',
      accountSearchLabel: '계정 검색',
      accountSearchPlaceholder: '계정 검색…',
      loadingAccounts: '계정 불러오는 중…',
      noAccounts: '일치하는 계정이 없습니다.',
      allDesktops: '현재 및 향후 모든 Desktop',
      allCloudAndDesktop: '모든 Repository 실행과 Desktop',
      clusterAdminAccount: 'Cluster 관리자 · 모든 Desktop',
      loadingProjects: '프로젝트 불러오는 중…',
      noProjects: '아직 프로젝트가 없습니다.',
      servicesCount: '{count}개 서비스',
      providerValidationRequired: '이름, 제공자 유형, Base URL은 필수입니다.',
      providerValidationKey: '새 API 키 제공자에는 API 키가 필요합니다.',
      providerSaved: '제공자가 저장되었습니다.',
      saveProviderError: '제공자를 저장할 수 없습니다.',
      providerAdded: '제공자가 추가되었습니다.',
      addProviderError: '제공자를 추가할 수 없습니다.',
      editProviderTitle: '제공자 편집 · {name}',
      addProviderTitle: '모델 제공자 추가',
      saveProvider: '제공자 저장',
      providerSourceLabel: '제공자 소스',
      providerRegistryMode: '제공자',
      providerCustomMode: '사용자 지정',
      providerSelectLabel: '제공자',
      providerSelectPlaceholder: '제공자 선택',
      providerNameLabel: '제공자 이름',
      providerNamePlaceholder: '예: Zhipu AI',
      providerTypeLabel: '제공자 유형',
      providerTypeHint: 'openai, qwen, zhipu와 같은 소문자 런타임 접두사입니다.',
      baseUrlLabel: 'Base URL',
      authLabel: '인증',
      authApiKey: 'API 키',
      authServiceIdentityOption: '서비스 ID',
      authNone: '자격 증명 없음',
      rotateApiKeyLabel: 'API 키 교체',
      apiKeyPlaceholderKeep: '비워 두면 현재 키를 유지합니다',
      apiKeyPlaceholderEnter: '제공자 키 입력',
      apiKeyHint: '쓰기 전용입니다. 저장된 값은 다시 읽을 수 없습니다.',
      catalogLabel: '모델 카탈로그',
      catalogAuto: '/models에서 검색',
      catalogDisabled: '사용 불가 — 커스텀 모델만',
      advancedLabel: '고급',
      headersHint: '이 제공자로 보내는 모든 요청에 추가되는 커스텀 헤더입니다. 값은 쓰기 전용입니다.',
      headersConfiguredHint: '커스텀 헤더가 구성되어 있습니다. 행을 추가해 교체하거나 비워 두면 유지됩니다.',
      headerKeyPlaceholder: '헤더 이름',
      headerValuePlaceholder: '값',
      addHeader: '헤더 추가',
      removeHeader: '헤더 제거',
      headerValidation: '각 헤더에는 이름과 값이 모두 필요합니다.',
    },
    connections: {
      loading: 'Cluster 연결 불러오는 중…',
      statusError: '연결 상태를 불러올 수 없습니다',
      configError: 'jtype 구성을 불러올 수 없습니다',
      eyebrow: '외부 시스템',
      title: '연결',
      description: 'Cluster 전역 엔드포인트와 ID 제공자입니다. 리포지토리 인증은 각 리포지토리 연결에서 관리됩니다.',
      configurationTabs: '연결 구성',
      integrationsTab: '통합 구성',
      loginTab: '로그인 설정',
      statusEyebrow: '적용 상태',
      statusTitle: '연결 상태',
      statusDescription: 'Cluster가 보고하는 읽기 전용 실행 상태를 편집 가능한 제공자 구성과 분리해 표시합니다.',
      configuredCount: '{count}개 설정됨',
      gitPolicyTitle: 'Git 제공자 정책',
      gitPolicySubtitle: '환경 소유 · 읽기 전용',
      giteaEnabled: 'Gitea 활성화됨',
      giteaDisabled: 'Gitea 비활성화됨',
      giteaUrlLabel: 'Gitea URL',
      clusterPatLabel: 'Cluster PAT',
      patConfigured: '설정됨 · 값 숨김',
      allowedHostsLabel: '허용된 호스트',
      unrestricted: '제한 없음',
      oobTitle: '변경은 별도 경로로 이루어집니다.',
      oobBody: '제공자 URL, PAT, 호스트 허용 목록은 배포 구성으로 유지되며, 이 페이지는 실제 적용 상태를 보고합니다.',
      authTitle: '인증',
      registeredUsers: '등록된 사용자 {count}명',
      oauthOn: 'OAuth 켜짐',
      tokenOnly: '토큰만',
      giteaOauthLabel: 'Gitea OAuth',
      githubOauthLabel: 'GitHub OAuth',
      consoleTokenLabel: '콘솔 토큰',
      consoleTokenValue: 'Cluster 관리자 폴백',
      oauthSecurityNote: 'OAuth 리디렉션 URI는 제공자 UI를 통해 변경합니다. API 패치는 클라이언트 시크릿을 교체하기 때문입니다.',
      githubUnavailableTitle: 'GitHub 로그인을 사용할 수 없습니다.',
      githubUnavailableBody: '구성된 GitHub OAuth 제공자가 없습니다. 제공자가 존재하기 전까지 UI는 작동하는 GitHub 버튼을 표시하지 않습니다.',
      providerHealth: {
        unknown: '확인하지 않음',
        healthy: '정상',
        partial: '기본 연결 정상',
        error: '오류',
        incomplete: '구성 미완료',
      },
      providerHealthError: '연결 확인 실패: {message}',
      githubAppSetupIncomplete: 'GitHub App 설정 미완료',
      instanceUrl: '인스턴스 URL',
      providerCapabilities: '공급자 기능',
      loginEnabled: '로그인 활성화',
      loginCapability: '로그인',
      loginCapabilityHint: '이 공급자를 Cloud 로그인에 사용할 수 있도록 합니다.',
      pluginEnabled: '플러그인 활성화',
      pluginCapability: '플러그인',
      pluginCapabilityHint: '리포지토리가 연결하여 사용할 수 있도록 합니다.',
      oauthClientId: 'OAuth 클라이언트 ID',
      oauthClientSecret: 'OAuth 클라이언트 시크릿',
      configuredReplace: '구성됨 — 입력하여 교체',
      enterSecret: '시크릿 입력',
      githubAppId: 'GitHub App ID',
      githubAppPrivateKey: 'GitHub App 개인 키',
      configuredPemReplace: '구성됨 — PEM을 붙여넣어 교체',
      pastePrivateKeyPem: '전체 개인 키 PEM 붙여넣기',
      privateKeyHint: '쓰기 전용입니다. Cloud는 PEM을 암호화하며 브라우저에 반환하지 않습니다.',
      webhookSecret: 'Webhook 시크릿',
      webhookSecretPlaceholder: 'GitHub에 구성한 것과 동일한 시크릿 입력',
      githubAppConfigurationIncomplete: 'GitHub App 구성이 완료되지 않았습니다',
      githubAppConfigurationIncompleteHint: '계정이 Installation을 나열할 수 있도록 App ID, 개인 키, 일치하는 Webhook 시크릿을 추가하세요.',
      testConnection: '연결 테스트',
      jtypeSaved: 'jtype 연결이 저장되었습니다.',
      jtypeSaveError: 'jtype를 저장할 수 없습니다.',
      jtypeOverrideRemoved: 'jtype DB 재정의가 제거되었습니다.',
      jtypeRemoveError: '재정의를 제거할 수 없습니다.',
      sourceDb: 'DB 재정의',
      sourceEnv: '환경 폴백',
      sourceNone: '미설정',
      jtypeKanban: 'jtype Kanban',
      pollingEvery: '{interval}마다 폴링',
      jtypeEffective: '적용됨',
      jtypeBroken: '손상됨',
      jtypeOff: '꺼짐',
      baseUrlLabel: 'Base URL',
      baseUrlHint: '이 클러스터가 연결하는 jtype 인스턴스. Kanban 자격 증명은 각 프로젝트 소유자가 링크별로 관리합니다.',
      boardTrafficNote: '보드 트래픽은 서버 프록시를 통과합니다. jtype 토큰은 브라우저로 전달되지 않습니다.',
      jtypeUnavailableTitle: 'jtype 구성을 사용할 수 없습니다.',
      removeOverride: '재정의 제거',
      saveJtype: 'jtype 저장',
      archiveTitle: '워크스페이스 아카이브',
      archiveSubtitle: '영구 워크스페이스 콜드 스토리지',
      archiveEnabled: '활성화됨',
      archiveUnavailable: '사용 불가',
      endpointLabel: '엔드포인트',
      bucketLabel: '버킷',
      idleWindowLabel: '유휴 기간',
      idleDays: '{count}일',
      archiveDisabledTitle: '장기 아카이브가 활성화되어 있지 않습니다.',
      archiveDisabledReason: '오브젝트 스토리지가 구성되어 있지 않습니다.',
    },
    system: {
      forbiddenTitle: 'Cluster 보기는 Cluster 관리자 전용입니다',
      forbiddenDescription: '이 역할은 프로젝트만 관리합니다. 용량, 가드레일, 제공자 세부 정보는 Cluster 관리자에게 문의하세요.',
      title: 'Cluster',
      subtitle: '이 오케스트레이터의 스냅샷: 용량, 가드레일, 연결 구성. 모델은 여기서 설정하며, 그 외 변경은 별도로(env / kubectl) 이루어집니다.',
      loadingSnapshot: 'Cluster 스냅샷 불러오는 중…',
      snapshotError: 'Cluster 스냅샷을 불러올 수 없습니다',
      noSnapshotTitle: '스냅샷 없음',
      noSnapshotDescription: '오케스트레이터가 시스템 정보를 반환하지 않았습니다.',
      capacityTitle: '용량',
      unlimitedConcurrency: '무제한 동시 실행',
      activeMax: '{active} 활성 / 최대 {max}',
      capacityBarAria: '최대 동시 실행 대비 활성 실행',
      statRunning: '실행 중',
      statScheduling: '스케줄링 중',
      statQueued: '대기 중',
      statMaxConcurrent: '최대 동시 실행',
      guardrailsTitle: '가드레일',
      runTimeoutLabel: '실행 시간 제한',
      jobTtlLabel: 'Job TTL',
      providerTitle: '제공자',
      giteaEnabled: 'Gitea 활성화됨',
      giteaDisabled: 'Gitea 비활성화됨',
      draftPrsLabel: '초안 PR',
      on: '켜짐',
      offDiffOnly: '꺼짐 (diff 전용)',
      giteaUrlLabel: 'Gitea URL',
      allowedHostsLabel: '허용된 git 호스트',
      unrestrictedAnyHost: '제한 없음 (모든 호스트)',
      allowedHostsHint: '프로젝트 통합은 이 호스트만 대상으로 할 수 있습니다 (ALLOWED_GIT_HOSTS). 비어 있으면 모든 호스트를 허용합니다.',
      runnerTitle: '러너',
      imageLabel: '이미지',
      namespaceLabel: '네임스페이스',
      launcherLabel: '런처',
      persistentWorkspaceLabel: '영구 워크스페이스',
      off: '꺼짐',
      authTitle: '인증',
      providerCount_one: '{count}개 제공자',
      providerCount_other: '{count}개 제공자',
      tokenOnly: '토큰만',
      oauthProvidersLabel: 'OAuth 제공자',
      noneConsoleToken: '없음 (콘솔 토큰만)',
      usersLabel: '사용자',
      versionTitle: '버전',
      orchestratorLabel: '오케스트레이터',
      commitLabel: '커밋',
      modelCatalogTitle: '모델 카탈로그',
      modelCount_one: '{count}개 모델',
      modelCount_other: '{count}개 모델',
      noModels: '모델 없음',
      modelCatalogHint: 'OpenAI 호환 엔드포인트를 등록한 다음 프로젝트별로 권한을 부여하세요. 프로젝트에 권한이 부여된 모델이 하나 이상 있을 때까지 실행이 차단됩니다.',
      loadingModelCatalog: '모델 카탈로그 불러오는 중…',
      modelCatalogError: '모델 카탈로그를 불러올 수 없습니다',
      noModelsYet: '아직 모델이 없습니다 — 아래에서 추가하세요.',
      keySet: '키 설정됨',
      keyless: '키 없음',
      modelSaved: '모델이 저장되었습니다.',
      modelSaveError: '모델을 저장할 수 없습니다.',
      modelRemoved: '모델이 제거되었습니다.',
      modelRemoveError: '모델을 제거할 수 없습니다.',
      nameLabel: '이름',
      baseUrlLabel: 'Base URL',
      modelProviderLabel: '모델 (제공자/모델)',
      apiKeyLabel: 'API 키',
      apiKeyPlaceholderClear: '지워집니다 (키 없음)',
      apiKeyPlaceholderRotate: '•••••••• (비워 두면 변경 없음, 입력하면 교체)',
      apiKeyPlaceholderNew: 'sk-…  (키 없으려면 비워 두세요)',
      apiKeyHint: '암호화되어 저장됩니다. 저장 후에는 표시되지 않습니다.',
      clearKeyLabel: '키 지우기 (이 엔드포인트를 키 없음으로 설정)',
      noProjectsToAuthorize: '아직 권한을 부여할 프로젝트가 없습니다.',
      authorizedProjects: '권한이 부여된 프로젝트',
      grantUpdateError: '권한 부여를 업데이트할 수 없습니다.',
      modelAdded: '모델이 추가되었습니다.',
      modelAddError: '모델을 추가할 수 없습니다.',
      apiKeyPlaceholderAdd: 'sk-…  (키 없는 엔드포인트는 비워 두세요)',
      addModel: '모델 추가',
    },
  },

  app: {
    linked: '{provider} 계정을 연결했습니다.',
    linkTaken: '해당 계정은 이미 다른 사용자에 연결되어 있습니다.',
    linkError: '해당 계정을 연결할 수 없습니다.',
    auth: {
      loginProviderDenied: '제공자가 로그인 요청을 거부했습니다. 다시 시도하세요.',
      loginExchangeFailed: '로그인을 완료할 수 없습니다 (토큰 교환 실패).',
      loginProfileFailed: '로그인 중 제공자에서 프로필을 읽을 수 없습니다.',
      loginServerMisconfigured: '서버에 로그인이 구성되어 있지 않습니다.',
      loginServerError: '서버가 로그인을 완료하는 중 오류가 발생했습니다.',
      loginFailed: '로그인에 실패했습니다. 다시 시도하세요.',
      enterToken: '콘솔 토큰을 입력하세요.',
      superseded: '대체됨.',
      tokenRejected: '오케스트레이터가 토큰을 거부했습니다.',
      lostOrchestrator: '오케스트레이터 연결이 끊겼습니다 — 설정 단계를 확인하세요.',
    },
  },

  components: {
    modelGate: {
      unverified: '모델 상태를 검증할 수 없습니다 — 사용 가능한 모델이 없으면 실행이 실패할 수 있습니다.',
      notConfigured: '이 프로젝트에 사용 가능한 모델이 없어 실행을 시작할 수 없습니다.',
      grantLink: 'Cluster 페이지에서 모델을 부여하세요',
      contactAdmin: '이 프로젝트에 모델을 부여하려면 Cluster 관리자에게 문의하세요.',
    },
    prPanel: {
      stateOpen: '열림',
      stateMerged: '병합됨',
      stateClosed: '닫힘',
      stateUnknown: '알 수 없음',
      stateAria: '풀 리퀘스트 상태: {state}',
      reviewRequested: 'AI 리뷰를 요청했습니다.',
      reviewError: '리뷰를 요청할 수 없습니다.',
      loading: '풀 리퀘스트 불러오는 중…',
      loadError: '풀 리퀘스트를 불러올 수 없습니다',
      noPr: '아직 열린 풀 리퀘스트가 없습니다.',
      requestReview: 'AI 리뷰 요청',
      reviewsTitle: '리뷰',
      reviewsEmpty: '아직 AI 리뷰가 없습니다.',
      hide: '숨기기',
      show: '표시',
      reviewFailed: '리뷰 실행이 출력을 생성하기 전에 실패했습니다.',
      reviewInProgress: '리뷰 진행 중…',
    },
    states: {
      cannotReach: '오케스트레이터에 연결할 수 없습니다. 실행 중인가요?',
      somethingWrong: '문제가 발생했습니다.',
      failedToLoad: '불러오지 못했습니다',
    },
    statusBadge: {
      queued: '대기 중',
      scheduling: '스케줄링 중',
      running: '실행 중',
      awaitingInput: '입력 대기 중',
      succeeded: '성공',
      failed: '실패',
      canceled: '취소됨',
      blocked: '차단됨',
      aria: '상태: {status}',
    },
    gitMode: {
      legend: 'Git 통합',
      modeAria: 'Git 통합 모드',
      readonlyLabel: '읽기 전용 diff',
      readonlyHint: '성공한 실행은 diff 아티팩트만 생성하며 아무것도 푸시하지 않습니다.',
      draftPrLabel: '초안 PR',
      draftPrHint: '성공하면 에이전트가 브랜치를 푸시하고 리뷰용 초안 PR을 엽니다. 자동 병합하거나 CI를 트리거하지 않습니다.',
      draftPrTitle: '성공한 실행은 브랜치를 푸시하고 리뷰용 초안 PR을 엽니다.',
      readonlyTitle: '성공한 실행은 diff 아티팩트만 생성하며 아무것도 푸시하지 않습니다.',
    },
    identity: {
      roleClusterAdmin: 'Cluster 관리자',
      roleProjectAdmin: '리포지토리 관리자',
      signOut: '로그아웃',
      serviceNote: '콘솔 토큰으로 인증됨 — 연결된 ID 없음.',
      session: '세션',
      linkedAccounts: '연결된 계정',
      noLinkedAccounts: '아직 연결된 계정이 없습니다.',
      linkAnother: '다른 계정 연결',
      link: '{name} 연결',
    },
    kanbanConnect: {
      startError: '연결 절차를 시작할 수 없습니다.',
      connect: 'jtype로 연결',
      enterCode: '승인하려면 jtype에 이 코드를 입력하세요:',
      openJtype: '승인하려면 jtype 열기',
      waiting: 'jtype에서 승인하기를 기다리는 중…',
      connected: '연결됨 — 토큰 설정됨',
      failed: '연결에 실패했습니다 — Connect를 다시 클릭하세요.',
      expired: '연결이 만료되었습니다 — Connect를 다시 클릭하세요.',
      unsupported: '이 jtype 배포는 원클릭 Connect를 지원하지 않습니다 — 대신 토큰을 붙여넣으세요.',
      expiryExpired: '만료됨',
      expiresInDays_one: '{count}일 후 만료',
      expiresInDays_other: '{count}일 후 만료',
    },
    projectSwitcher: {
      allProjects: '모든 프로젝트',
      noProjects: '아직 프로젝트가 없습니다',
    },
    modal: {
      close: '대화상자 닫기',
    },
  },


  members: {
    addedAs: '{name}이(가) {role}(으)로 추가되었습니다.',
    addError: '멤버를 추가할 수 없습니다.',
    updateRoleError: '역할을 업데이트할 수 없습니다.',
    removed: '{name}이(가) 제거되었습니다.',
    removeError: '멤버를 제거할 수 없습니다.',
    searchPlaceholder: '이름으로 사용자 검색…',
    searchAria: '추가할 사용자 검색',
    searching: '검색 중…',
    noMatches: '일치하는 사용자가 없습니다.',
    adminTag: '관리자',
    roleForAddedAria: '추가된 멤버의 역할',
    roleForAria: '{name}의 역할',
    removeAria: '{name} 제거',
    loading: '멤버 불러오는 중…',
    loadError: '멤버를 불러올 수 없습니다',
    roleOwner: '소유자',
    roleMember: '멤버',
    roleViewer: '뷰어',
  },


  kanban: {
    enableTitle: 'Agent Board 연결',
    enableBody: '기존 Board, 실행 모델, 시작·진행 중·선택적 완료 열을 선택하세요.',
    pluginRequired: '먼저 JType을 연결하고 워크스페이스를 선택한 뒤 Agent Board를 연결하세요.',
    loadingAccountModels: '계정 모델 불러오는 중…',
    accountModelsUnavailable: '계정 모델을 불러올 수 없습니다.',
    accountModelRequired: 'Agent Board를 활성화하기 전에 이 계정에 모델을 하나 이상 승인하세요.',
    loadingBoards: '보드 불러오는 중…',
    boardsUnavailable: '보드를 불러올 수 없습니다. JType 플러그인 연결을 확인하세요.',
    enable: 'Agent Board 연결',
    disable: '연결 해제',
    triggerColumn: '트리거 열',
	workColumn: '진행 중 열',
    doneColumn: '완료 열',
    noDoneColumn: '완료 후 카드를 이동하지 않음',
    columnSettings: '자동화 열',
    columnSettingsHint: '카드가 작업을 시작하는 열과 완료 후 이동할 위치를 인라인으로 편집합니다.',
    columnsUnavailable: '열 옵션을 불러올 수 없습니다. JType 플러그인 연결을 확인하세요.',
    notConfiguredTitle: 'Kanban이 구성되어 있지 않습니다',
    notConfiguredMsg: '이 보드를 열려면 Cluster 관리자가 jtype 통합을 구성해야 합니다.',
    tlsInvalidTitle: 'JType 인증서 복구가 필요합니다',
    tlsInvalidMsg: 'JType의 HTTPS 인증서를 확인할 수 없습니다. 관리자에게 인증서 갱신 또는 복구를 요청한 후 다시 시도하세요.',
    unavailableTitle: 'Kanban을 사용할 수 없습니다',
    unavailableMsg: 'jtype 서비스에 연결할 수 없습니다. 서비스를 사용할 수 있을 때 다시 시도하세요.',
    unauthorizedTitle: 'Kanban 액세스에 주의가 필요합니다',
    unauthorizedMsg: '현재 JType 연결이 이 Board를 읽을 수 없습니다. Repository owner 또는 Cluster 관리자가 연결을 복구해야 합니다.',
    workspaceNotFoundTitle: 'Kanban 워크스페이스를 찾을 수 없습니다',
    workspaceNotFoundMsg: '이 Agent Board는 더 이상 사용할 수 없는 JType 워크스페이스를 가리킵니다.',
    boardNotFoundTitle: '이 보드를 열 수 없습니다',
    boardNotFoundMsg: '보드가 삭제되거나 이름이 변경되었거나, 통합이 액세스를 잃었을 수 있습니다.',
    boardOpenDefaultMsg: '지금 Board를 열 수 없습니다. 다시 시도하거나 Repository owner에게 연결 확인을 요청하세요.',
    title: 'Agent Board',
    boardLabel: '보드',
    openingBoard: '보드 여는 중…',
    loadingPolicy: '실행 정책 불러오는 중…',
    policyUnavailable: '실행 정책을 불러올 수 없습니다.',
    policyTrigger: 'Card가 {column}에 들어가면 jcode 시작',
	policyWork: '수락된 Card를 {column}(으)로 이동',
	policyWorkMissing: '수락된 Card가 WIP로 이동되지 않음',
    policyWriteback: '성공 시 댓글을 남기고 {column}(으)로 이동',
    policyCommentOnly: '결과를 Card 댓글로 기록',
    policyReady: '실행 가능',
    policyBlocked: '차단됨 · {blocker}',
    policyBlockers: {
      binding_disabled: '자동화 비활성화됨',
      plugin_unavailable: 'JType 연결 사용 불가',
      event_feed_unavailable: 'JType 이벤트 피드 사용 불가',
      bootstrap_unavailable: 'JType 카드 초기화 사용 불가',
      card_index_unavailable: 'JType Card 인덱스 사용 불가',
      card_read_unavailable: 'JType 카드를 일시적으로 읽을 수 없음',
      card_unavailable: 'JType 카드 사용 불가',
      board_validation_unavailable: 'JType 보드를 검증할 수 없음',
      board_drift: '보드 또는 자동화 열이 변경됨',
      repository_not_configured: '저장소가 구성되지 않음',
      repository_unavailable: '저장소 연결 사용 불가',
      provider_unavailable: '저장소 Provider 사용 불가',
      runner_unavailable: 'Runner 사용 불가',
      run_unavailable: '연결된 Cloud Run 사용 불가',
      model_not_configured: '모델이 구성되지 않음',
      model_not_authorized: '실행 계정에 모델 권한이 없음',
      model_authorization_unavailable: '모델 권한을 확인할 수 없음',
      execution_account_not_owner: '실행 계정이 더 이상 Repository owner가 아님',
      work_column_not_configured: '진행 중 열이 구성되지 않음',
      model_effort_unsupported: '선택한 추론 강도를 지원하지 않음',
    },
    executionsTitle: 'Cloud 실행',
    loadingExecutions: 'Cloud 실행 불러오는 중…',
    executionsUnavailable: 'Cloud 실행 기록을 불러올 수 없습니다.',
    noExecutions: '아직 Cloud 실행이 없습니다. 이 Card를 “jcode 시작” 열로 옮겨 요청하세요.',
    runWithAgent: 'Agent로 실행',
    agentRunActive: 'Agent 실행 중',
    rerunDoneConfirm: '이 Card는 Done 열에 있습니다. 다시 실행하고 진행 중 열로 이동할까요?',
    executionState: {
      received: '요청 수신',
      blocked: '차단됨',
      queued: '대기 중',
      running: '실행 중',
      terminal: '종료',
      succeeded: '성공',
      failed: '실패',
      canceled: '취소됨',
    },
    requestedByExternal: '요청자: {actor}',
    projectOwner: '프로젝트 소유자',
    repositoryOwner: '저장소 소유자',
    clusterAdmin: 'Cluster 관리자',
    openRun: 'Run 열기',
    writebackPending: 'Card 라이트백 대기 중',
    writebackUnavailable: '원본 Card 사용 불가',
    executionSummary: {
      received: 'Card 요청을 받았습니다.',
      queued: 'Run이 대기 중입니다.',
      running: 'Run이 요청된 변경을 수행 중입니다.',
      succeeded: 'Run이 성공적으로 완료되었습니다.',
      failed: 'Run이 실패했습니다.',
      canceled: 'Run이 취소되었습니다.',
    },
    priorExecutions_one: '이전 실행 {count}개',
    priorExecutions_other: '이전 실행 {count}개',
    cardUnavailable: '이 Card는 더 이상 JType에 없습니다. Cloud 실행 기록은 보존됩니다.',
    loadEarlierExecutions: '이전 실행 불러오기',
    linkDisabledTitle: '이 Kanban 자동화 링크가 비활성화되어 있습니다.',
    linkDisabledBody: '보드는 볼 수 있지만 카드 트리거 실행과 라이트백은 비활성화되어 있습니다.',
  },

  onboarding: {
    setupStep1: '로컬 이미지 4개 빌드',
    setupStep2: 'OrbStack 클러스터에 배포하고 롤아웃을 기다리세요',
    setupStep3: '오케스트레이터 API를 localhost:8080으로 포워딩하세요',
    probingEyebrow: '연결 중',
    probingTitle: '런타임을 연결하세요.',
    probingStory: '콘솔이 인증된 워크플로를 시작할 수 있는지 확인하고 있습니다.',
    probingUtility: '연결 설정',
    probingStatus: '프로빙 중',
    setupEyebrow: '로컬 설정',
    setupTitle: '런타임을 연결하세요.',
    setupStory: '콘솔이 준비되었습니다. 오케스트레이터가 아직 응답하지 않아 인증된 워크플로를 시작할 수 없습니다.',
    setupUtility: '연결 설정',
    setupStatus: '연결 불가',
    signinEyebrow: '당신의 코드. 당신의 클러스터.',
    signinTitle: '작업을 시스템 가까이 두세요.',
    signinStory: 'jcode Cloud는 팀이 이미 제어하는 인프라로 코딩 작업을 디스패치합니다.',
    signinUtility: '보안 진입',
    signinStatus: '로그인',
    welcomeEyebrow: '워크스페이스 준비됨',
    welcomeTitle: '첫 경계를 설정할 사람은 당신입니다.',
    welcomeStory: '가장 먼저 로그인하셨습니다. jcode Cloud가 이 ID에 Cluster 관리자 역할을 할당했습니다.',
    welcomeUtility: '첫 사용자 설정',
    welcomeStatus: '로그인됨',
    landingEyebrow: '세션 준비됨',
    landingTitle: '컨트롤 플레인에 연결되었습니다.',
    landingStory: '콘솔 토큰이 이 브라우저에 Cluster 관리자 세션을 설정했습니다.',
    landingUtility: '세션 경계',
    landingStatus: '인증됨',
    selfHosted: '셀프 호스팅',
    assignedRole: '할당된 역할',
    clusterAdministrator: 'Cluster 관리자',
    adminSeparate: 'Cluster 관리는 리포지토리 소유권과 별개입니다.',
    roleManageGrants: '모델 권한 부여 관리',
    roleConfigureConnections: '연결 구성',
    roleViewCapacity: '용량 및 정책 보기',
    sessionBoundary: '세션 경계',
    whatSignInEstablishes: '로그인이 설정하는 것',
    signInEstablishesBody: '오케스트레이터는 제공자 ID를 하나의 jcode Cloud 계정에 매핑합니다. 리포지토리 소유권과 제공자 액세스는 별도로 평가됩니다.',
    providerTokensServerSide: '제공자 토큰은 서버 측에 유지되며 이 페이지에 렌더링되지 않습니다.',
    currentProbe: '현재 프로브',
    whatConsoleKnows: '콘솔이 아는 것',
    probeBody: '이 상태는 연결 가능 여부만 보고합니다. Kubernetes, 이미지, 자격 증명이 정상인지는 추론하지 않습니다.',
    probeTarget: '대상',
    probeResponse: '응답',
    probeUnreachable: '연결 불가',
    probeWaiting: '대기 중',
    cantReachTitle: '오케스트레이터에 연결할 수 없습니다',
    setupLede1: '콘솔은',
    setupLede2: '을(를)',
    setupLede3: '(으)로 프록시하지만 아무 응답이 없습니다. 스택을 실행하면 이 페이지가 자동으로 넘어갑니다.',
    recheckingNote: '3초마다 다시 확인 중 — 새로고침이 필요 없습니다',
    checkNow: '지금 확인',
    reasonRejected: '저장된 토큰이 거부되었습니다 — 교체되었을 수 있습니다. 현재 토큰을 입력하세요.',
    reasonExpired: '세션이 종료되었습니다 (만료 또는 취소됨). 다시 로그인하세요.',
    reasonSignedOut: '로그아웃되었습니다.',
    continueWith: '{name}(으)로 계속',
    signInHeading: '로그인',
    signInLedeNoProviders: '구성된 OAuth 제공자가 없습니다. 오케스트레이터 배포 시 사용한 콘솔 토큰을 사용하세요.',
    signInLedeProviders: 'git 제공자로 계속하여 개인별 세션을 받으세요.',
    advancedConsoleToken: '고급: 콘솔 토큰',
    consoleTokenLabel: '콘솔 토큰',
    consoleTokenHint: '오케스트레이터 배포 시 사용한 CONSOLE_TOKEN — Cluster 관리자용. 이 브라우저에 로컬로 저장됩니다.',
    signInWithToken: '토큰으로 로그인',
    welcomeFirstAdminTitle: '첫 사용자입니다 — Cluster 관리자',
    welcomeGreeting: '환영합니다, {name}님',
    welcomeFirstAdminLede: '가장 먼저 로그인하셨으므로 이제 Cluster 관리자입니다: 모든 프로젝트를 보고 용량을 관리할 수 있습니다. 이후 참여하는 모든 사람은 일반 사용자로 시작합니다.',
    welcomeLede: '로그인되었습니다. jcode Cloud를 리포지토리에 연결하려면 프로젝트를 만들거나, 추가된 프로젝트를 여세요.',
    friend: '친구',
    signedInAs: '{name}(으)로 로그인됨',
    getStarted: '시작하기',
    landingCardTitle: '입장했습니다 — Cluster 관리자',
    landingLede: '이 오케스트레이터에 로그인됨:',
    principal: '주체',
    access: '액세스',
    accessClusterAdmin: 'Cluster 관리자',
    accessMember: '멤버',
    session: '세션',
    sessionConsoleToken: '콘솔 토큰',
    sessionUser: '사용자 세션',
    identity: 'ID',
    everythingHeadless: '모든 작업이 클러스터에서 무인으로 실행됩니다.',
    enterConsole: '콘솔 진입',
    connecting: '오케스트레이터에 연결 중…',
    mobileHandoff: '휴대폰에서 로그인 완료 중…',
    mobileConsentTitle: '휴대폰에서 로그인',
    mobileConsentLede: '{name}(으)로 로그인되어 있습니다. 아래 버튼을 탭하여 모바일 앱 로그인을 완료하세요.',
    mobileConsentContinue: '앱으로 계속',
  },

  notFound: {
    title: '이 경로는 여기서 끝납니다.',
    body: '페이지가 이동했거나, 링크가 더 이상 액세스할 수 없는 리포지토리 또는 작업을 가리킬 수 있습니다.',
    backToProjects: '리포지토리로 돌아가기',
  },

  device: {
    compose: {
      project: '작업 디렉터리',
      model: '모델',
      effort: '강도',
      goal: '목표',
      goalPlaceholder: '이 세션에서 달성할 것은 무엇인가요?',
      attachments: '첨부 파일',
      attachAdd: '파일 첨부',
      removeAttachment: '{name} 제거',
      deviceDefault: '디바이스 기본값',
      attachmentTooBig: '{name} 파일이 2MB를 초과합니다 — 더 작은 파일을 선택하세요.',
      attachmentTooMany: '메시지당 첨부 파일은 최대 {max}개입니다.',
      attachmentImage: '{name} 파일은 이미지입니다 — 이미지는 아직 지원되지 않습니다.',
    },
    composer: {
      placeholder: 'jcode에 지시 입력, / 로 명령 사용',
      goalPlaceholder: '목표를 설명하세요 — 검증 가능하게 완료될 때까지 에이전트가 추구합니다',
      queuePlaceholder: '에이전트 작업 중 — 입력하면 후속 메시지가 큐에 쌓입니다…',
      attachedImages: '(첨부 이미지 참조)',
      send: '보내기',
      queue: '큐에 추가',
      stop: '중지',
      stopAgent: '에이전트 중지 (Esc)',
      stopAndNext: '현재 턴을 중지하고 다음 큐 메시지 보내기',
      removeQueued: '큐에서 제거',
      add: '추가',
      attachFiles: '파일 첨부',
      command: '명령',
      goal: '목표',
      workflowBadge: '워크플로',
      goalSlashDesc: '목표 모드 켜기 — 다음 메시지가 목표가 됩니다',
      goalHintNext: '다음 메시지가 세션 목표가 됩니다',
      goalHintNextReplaces: '다음 메시지가 현재 목표를 대체합니다',
      goalHintRemove: '목표 해제',
      goalHintReplace: '새 목표를 설정하면 현재 목표가 대철됩니다',
      modelNoImages: '현재 모델은 이미지를 지원하지 않습니다',
      modeApproval: '매번 확인',
      modeApprovalSub: '쓰기나 명령 실행 전에 매번 확인합니다.',
      modePlan: '계획',
      modePlanSub: '먼저 계획을 제시합니다. 승인 전까지 아무것도 실행하지 않습니다.',
      modeAuto: '자동',
      modeAutoSub: 'AI 리뷰어가 안전한 도구를 허용하고, 불확실한 것은 묻습니다.',
      modeFullAccess: '전체 허용',
      modeFullAccessSub: '자유롭게 실행 — 승인 프롬프트 없음.',
      modeCeilingHint: '클우드 세션은 Auto 모드까지 사용할 수 있습니다.',
      modelFilter: '모델 필터…',
      modelCurrent: '현재',
      modelFavorites: '★ 즐겨찾기',
      modelReasoning: '추론',
      modelTools: '도구 사용',
      modelImages: '이미지 입력',
      modelNoImageInput: '현재 모델은 이미지 입력을 지원하지 않습니다',
      modelNone: '사용 가능한 모델이 없습니다',
      modelNoMatch: '필터와 일치하는 모델이 없습니다.',
      modelManage: '모델 관리…',
      modelManageTitle: '모델 관리',
      modelToggleVisibility: '모델 선택기에 표시할 모델 전환',
      modelVisibleCount: '선택기에 {visible}/{total}개 모델 표시 중',
      effort: '추론 강도',
      effortTitle: '이 모델의 추론 강도',
      effortDefault: '기본값',
      contextTitle: '컨텍스트 용량',
      contextSystemPrompt: '시스템 프롬프트',
      contextSystemTools: '시스템 도구',
      contextMcpTools: 'MCP 도구',
      contextSkills: '스킬',
      contextMessages: '메시지',
      contextInput: '입력',
      contextOutput: '출력',
      contextCached: '캐시',
      contextReasoning: '추론',
      contextCacheHitRate: '캐시 적중률',
      workspaceNone: '폴더 선택',
      workspaceUnavailable: '현재 폴더를 읽을 수 없습니다. 다시 시도하거나 폴더를 선택하세요. Chat을 사용하려면 기기의 jcode를 업데이트하세요.',
      workspaceNewConversation: '기기 페이지로 돌아가 새 대화의 작업 공간을 선택하세요.',
      workspaceNonePlural: '워크스페이스 없음',
      workspaceSearch: '워크스페이스 검색',
      workspaceLoading: '로딩 중…',
      workspaceNoFolders: '폴더 없음',
      workspaceOpen: '열기',
      workspaceOpenFolder: '폴더 열기',
      workspaceOpenError: '워크스페이스를 열지 못했습니다',
      workspacePathPlaceholder: '기기상의 경로',
      remoteConnect: '원격 연결',
      branchesTitle: '브랜치',
      branchesNone: '브랜치 없음',
      branchSearch: '브랜치 검색',
      branchCreate: '새 브랜치 만들고 체크아웃',
      branchCreateBtn: '만들기',
      branchNewName: 'new-branch-name',
      branchCurrent: '브랜치: {name}',
      branchConfirmTitle: '커밋되지 않은 변경 사항',
      branchConfirmIntro: '"{branch}"(으)로 전환하면 다음 로컬 파일을 덮어씁니다:',
      branchConfirmMore: '외 {count}개',
      branchConfirmStash: '스태시 후 전환',
      branchConfirmDiscard: '버리고 전환',
      branchConfirmCancel: '취소',
      branchConfirmHint: '스태시는 git stash pop으로 복구할 수 있습니다. 버리기는 추적되지 않은 파일을 포함해 영구 삭제합니다.',
      branchSwitchError: '브랜치 전환에 실패했습니다',
      goalStatusActive: '활성',
      goalStatusCompleted: '완료',
      goalStatusBlocked: '차단됨',
      goalStarted: '시작',
      goalElapsed: '경과',
      goalEdit: '편집',
      goalEditTitle: '목표 편집',
      goalClear: '목표 지우기',
      goalSaveFailed: '목표를 저장하지 못했습니다',
      goalTokens: '{used} tokens',
      goalTokensK: '{k}k tokens',
      durationSeconds: '{n}초',
      durationMinutes: '{m}분 {s}초',
      durationHours: '{h}시간 {m}분',
      commonTokens: '{used} tokens',
      commonLoading: '로딩 중…',
      commonClose: '닫기',
      commonCancel: '취소',
      commonSave: '저장',
      commonDone: '완료',
      commonEnable: '활성화',
      commonDisable: '비활성화',
      commonRecommended: '추천',
    },
    list: {
      title: '기기',
      subtitle: '계정에 연결된 jcode 기기입니다. 온라인 상태의 모든 머신에 작업을 보낼 수 있습니다.',
      emptyTitle: '아직 기기가 없습니다',
      emptyBody: '머신에서 `jcode login`을 실행하여 jcode Cloud에 연결하세요.',
      online: '온라인',
      offline: '오프라인',
      lastSeen: '마지막 확인 {time}',
      neverSeen: '확인된 적 없음',
      loadErrorTitle: '기기를 불러올 수 없습니다',
      servicePrincipal: '기기는 사용자 계정에 연결됩니다. 콘솔 서비스 토큰이 아닌 사용자 세션으로 로그인하세요.',
      platformDesktop: '데스크톱',
      platformCli: 'CLI',
      e2ee: '종단간 암호화',
      e2eeWithKeyGen: '종단간 암호화 · 키 세대 {gen}',
    },
    welcome: {
      back: '기기',
      newSession: '새 세션',
      composerPlaceholder: 'jcode에게 무엇이든 물어보세요…',
      send: '보내기',
      mode: '모드',
      sessions: '세션',
      sessionCount_one: '{count}개 세션',
      sessionCount_other: '{count}개 세션',
      noSessions: '아직 세션이 없습니다. 메시지를 보내 시작하세요.',
      creating: '세션을 만드는 중…',
      createSlow: '기기 응답이 느립니다. 잠시 후 세션이 표시됩니다.',
      untitled: '제목 없는 세션',
      offlineBanner: '이 기기는 오프라인입니다. 다시 연결될 때까지 메시지를 보낼 수 없습니다.',
      delete: '기기 삭제',
      deleteConfirm: '{name}을(를) 삭제하시겠습니까? 기기가 로그아웃되고 동기화가 중지됩니다. 세션 기록은 서버에 보관됩니다.',
      deleted: '기기 {name}을(를) 삭제했습니다',
      sessionDelete: '세션 삭제',
      sessionDeleteRunning: '삭제하기 전에 세션을 중지하세요',
      sessionDeleteConfirm: '“{name}”을(를) 데스크톱과 클라우드에서 삭제할까요?',
      sessionDeleted: '“{name}” 세션을 삭제했습니다',
      status: {
        idle: '유휴',
        running: '실행 중',
      },
    },
    session: {
      back: '기기로 돌아가기',
      thinking: '생각 중',
      thinkingAria: '생각 중…',
      you: '나',
      send: '보내기',
      stop: '중지',
      composerPlaceholder: 'jcode에 메시지 보내기…',
      offlineBanner: '기기가 오프라인입니다. 다시 연결될 때까지 전송이 비활성화됩니다.',
      streamError: '라이브 스트림이 중단되었습니다. 다시 연결 중…',
      reconnect: '다시 연결',
      approve: '승인',
      approveAll: '항상 허용',
      deny: '거부',
      toolDenied: '거부됨',
      askUser: 'jcode가 질문했습니다(기기에서 답변하세요):',
      agentStarted: '에이전트가 시작되었습니다',
      agentDone: '에이전트가 완료되었습니다',
      agentStopped: '사용자가 중지했습니다',
      agentFailed: '에이전트 실패: {message}',
      taskRunning: '세션 실행 중',
      taskIdle: '세션 유휴 상태',
      modeChanged: '모드가 {mode}(으)로 변경되었습니다',
      modelChanged: '모델이 {model}(으)로 변경되었습니다',
      sessionReset: '세션이 초기화되었습니다',
      todoUpdated: '할 일이 업데이트되었습니다',
      goalUpdated: '목표가 업데이트되었습니다: {objective}',
      goalCleared: '목표가 지워졌습니다',
      subagentStarted: '하위 에이전트 {name}이(가) 시작되었습니다',
      subagentDone: '하위 에이전트 {name}이(가) 완료되었습니다',
      subagentFailed: '하위 에이전트 {name}이(가) 실패했습니다',
      sendFailed: '보낼 수 없습니다: {message}',
      deviceOffline: '기기가 오프라인입니다',
      emptyHistory: '이 세션에는 아직 이벤트가 없습니다.',
      source: {
        console: '콘솔',
        mobile: '모바일',
        desktop: '데스크톱',
        wechat: 'WeChat',
        local: '로컬',
      },
    },
    guide: {
      entry: '사용 가이드',
      title: 'jcode 디바이스 사용하기',
      subtitle: '`jcode login`으로 머신을 연결하고 브라우저나 모바일 앱에서 제어하는 방법.',
      back: '디바이스 목록으로',
      shots: {
        devices: '클우드 콘솔의 디바이스 목록',
        welcome: '디바이스 페이지: 새 세션 시작과 기존 세션 탐색',
        session: '디바이스에서 실시간으로 스트리밍되는 세션',
        offline: '오프라인 디바이스도 히스토리를 보여줍니다',
        login: '모바일 앱 로그인 화면',
      },
      what: {
        title: '"디바이스"란?',
        p1: '디바이스는 jcode(CLI 또는 데스크톱)를 실행하고 `jcode login`으로 jcode Cloud에 로그인한 머신입니다. 연결되면 클라우드 콘솔이나 모바일 앱에서 그 머신을 원격으로 보고 제어할 수 있습니다.',
        p2: '클우드는 트래픽을 중계할 뿐입니다. 머신이 클라우드로 아웃바운드 연결을 하므로 인바운드 포트나 VPN이 필요 없습니다. 세션은 항상 머신에서 실행되고 저장됩니다.',
      },
      quickstart: {
        title: '빠른 시작',
        p1: '제어하려는 머신에서 실행하세요:',
        code1: 'jcode login',
        p2: 'CLI가 코드와 확인 링크를 출력합니다. 브라우저에서 로그인을 승인하세요. 이후 디바이스가 자동으로 연결되어 디바이스 목록에 나타납니다.',
        p3: '기본값은 https://cloud.j-code.net입니다. 셀프 호스팅이라면 URL을 전달하세요. https여야 합니다(일반 http는 개발용 localhost만 허용):',
        code2: 'jcode login --cloud https://your-cloud.example.com',
      },
      remote: {
        title: '디바이스 원격 사용',
        p1: '디바이스 목록을 열고 디바이스를 선택하세요. 새 세션 시작, 실행 중 세션 실시간 보기, 실행 중지, 승인 프롬프트 응답 등 머신 본체와 같은 조작이 가능합니다.',
        p2: '디바이스가 오프라인이어도 세션 히스토리는 볼 수 있지만, 메시지 전송과 승인은 다시 연결될 때까지 비활성화됩니다.',
      },
      pairing: {
        title: '페어링과 종단간 암호화',
        p1: '세션 내용은 종단간 암호화됩니다. 클라우드에는 암호문과 라우팅 메타데이터만 저장되므로 세션을 읽을 수 없습니다. 새 클라이언트(새 브라우저나 휴폰)는 내용을 복호화하기 전에 디바이스와 페어링해야 합니다.',
        p2: '브라우저 또는 모바일 앱에서 페어링을 시작한 뒤 기기의 jcode Desktop에서 설정 → 클라우드를 여세요. 클라이언트 이름을 확인하고 10분 이내에 승인하거나 거부하세요. CLI는 자동화에도 사용할 수 있습니다:',
        code1: 'jcode cloud pairings',
        code2: 'jcode cloud approve <pairing_id>',
        p3: '승인은 Desktop의 설정 → 클라우드 화면을 권장합니다. 자동화에서는 `pairings`로 대기 요청을 확인하고 `approve`로 승인할 수 있습니다(거부는 `jcode cloud deny <pairing_id>`).',
      },
      keys: {
        title: '키와 복구',
        p1: '암호화 키(CEK)는 첫 디바이스에서 생성되며 평문으로 디바이스 밖에 나가지 않습니다. 24단어 복구 구문으로 한 번 백업해 안전한 곳에 보관하세요:',
        code1: 'jcode cloud key show-phrase',
        p2: '모든 디바이스를 잃어버렸다면, 새로 로그인한 디바이스에서 구문으로 키를 복구합니다:',
        code2: 'jcode cloud key recover',
        p3: '키를 교체하려면(페어링된 클라이언트는 다시 페어링 필요):',
        code3: 'jcode cloud rotate-key',
      },
      commands: {
        title: '명령어 레퍼런스',
        p1: '자주 쓰는 명령어(모두 디바이스에서 실행):',
        rows: {
          login: '이 머신을 jcode Cloud에 로그인합니다(디바이스 코드 플로우).',
          loginStatus: '현재 로그인 상태를 표시하고 종료합니다.',
          logout: '로그아웃하고 디바이스 토큰을 폐기하며 로컬 자격 증명을 삭제합니다.',
          cloudStatus: '클우드 URL, 디바이스 ID, 키 세대, 연결 상태를 표시합니다.',
          pairings: '클라이언트의 대기 중인 페어링 요청을 나열합니다.',
          approve: '페어링 요청을 승인합니다(암호화된 키를 클라이언트에 전달).',
          deny: '페어링 요청을 거절합니다.',
          showPhrase: '암호화 키의 24단어 복구 구문을 표시합니다.',
          recover: '복구 구문으로 암호화 키를 재구성합니다.',
          rotateKey: '새 키를 생성합니다(key_gen+1). 페어링된 클라이언트는 다시 페어링해야 합니다.',
        },
        e2eeNote: 'E2E 암호화는 기본적으로 켜져 있습니다. 일시적으로 끄려면(평문 업링크, 디버깅용) `~/.jcode/config.json`에 "cloud": { "e2ee": false }를 설정하고 `jcode web`을 재시작하세요.',
      },
    },
    pairing: {
      start: '이 클라이언트 페어링',
      requests: {
        title: '페어링 요청',
        body: '승인된 이 클라이언트에서 다른 브라우저나 휴대폰을 안전하게 승인할 수 있습니다.',
        approve: '승인',
        deny: '거부',
        approvalLost: '이 클라이언트의 승인이 취소되었습니다. 먼저 다시 페어링하세요.',
      },
      idle: {
        title: '종단 간 암호화가 설정되지 않았습니다',
        body: '이 클라이언트에서 페어링을 시작하세요. jcode Desktop의 설정 → 클라우드에 검토 요청이 표시되며, 승인하기 전에는 암호화된 내용이 잠긴 상태로 유지됩니다.',
      },
      pending: {
        title: '기기 승인 대기 중',
        body: '기기의 jcode Desktop에서 설정 → 클라우드를 열고 이 클라이언트를 확인한 뒤 10분 이내에 승인하거나 거부하세요.',
      },
      denied: {
        title: '페어링이 거부되었습니다',
        body: '기기가 이 페어링 요청을 거부했습니다. 실수였다면 새로 시작하세요.',
      },
      expired: {
        title: '페어링이 만료되었습니다',
        body: '페어링 요청이 10분 이내에 승인되지 않았습니다. 새로 시작하세요.',
      },
      gate: {
        title: '페어링 필요',
        body: '이 기기는 종단 간 암호화를 강제합니다. 페어링이 완료되기 전까지 세션 내용과 제어를 사용할 수 없습니다.',
      },
      error: {
        title: '페어링 실패',
        body: '페어링 중 문제가 발생했습니다. 다시 시도하세요.',
      },
    },
    securityEyebrow: '기기 로그인',
    title: '기기 승인',
    lede: 'jcode Desktop이 이 클라우드에 로그인을 요청하고 있습니다. Desktop에 표시된 코드를 입력하세요.',
    safetyTitle: '직접 시작한 요청만 승인하세요',
    enterTitle: 'Desktop의 코드 입력',
    codeLabel: '기기 코드',
    codeHint: 'jcode Desktop에 표시된 8자리 코드입니다(예: XXXX-XXXX).',
    codeCell: '{total}자 중 {n}번째',
    codeRequired: 'jcode Desktop에 표시된 코드를 입력하세요.',
    continue: '계속',
    confirmTitle: '이 기기가 본인의 기기인가요?',
    confirmBody: '이 코드가 jcode Desktop에 표시된 현재 로그인 요청과 일치할 때만 승인하세요.',
    approve: '승인',
    deny: '거부',
    approvedTitle: '기기가 승인되었습니다',
    approvedBody: 'jcode Desktop으로 돌아가면 로그인이 자동으로 완료됩니다.',
    deniedTitle: '기기가 거부되었습니다',
    deniedBody: '로그인 요청이 거부되었습니다. jcode Desktop이 대기를 중단합니다.',
    another: '다른 기기 승인',
    unavailableTitle: '이 로그인 요청은 더 이상 사용할 수 없습니다',
    tryAnotherCode: '다른 코드 입력',
    backToDevices: '기기 목록으로 돌아가기',
    errorNotFound: '해당 코드와 일치하는 대기 중인 로그인이 없습니다. 만료되었을 수 있습니다. jcode Desktop에서 다시 시작하세요.',
    errorAlreadyDecided: '해당 로그인은 이미 승인 또는 거부되었습니다.',
    errorGeneric: '기기를 승인할 수 없습니다. 다시 시도하세요.',
  },

  projectDetail: {
    promptRequired: '에이전트가 수행할 작업을 설명하세요.',
    sessionStarted: '세션이 시작되었습니다.',
    startRunFailed: '실행을 시작하지 못했습니다.',
    defaultModelUpdated: '기본 모델이 업데이트되었습니다.',
    defaultModelFailed: '기본 모델을 설정할 수 없습니다.',
	runnerProfileUpdated: '런타임 프로필이 업데이트되었습니다.',
	runnerProfileFailed: '런타임 프로필을 설정할 수 없습니다.',
    repoAdded: '리포지토리 “{name}”이(가) 추가되었습니다.',
    addRepoFailed: '리포지토리를 추가하지 못했습니다.',
    nameRequired: '이름은 필수입니다.',
    repoUrlRequired: '리포지토리 URL은 필수입니다.',
    draftPrNeedsProviderUrl: '초안 PR에는 제공자 리포지토리 URL이 필요합니다.',
    loadingProject: '프로젝트 불러오는 중…',
    loadFailedTitle: '프로젝트를 불러올 수 없습니다',
    projects: '프로젝트',
    cluster: 'Cluster',
    projectWorkspace: '프로젝트 워크스페이스',
    addService: '서비스 추가',
    deleteService: '서비스 삭제',
    deleteServiceAria: '{name} 서비스 삭제',
    deleteServiceConfirm: '“{name}” 서비스를 삭제할까요? 실행 중인 작업을 먼저 중지한 뒤 이 서비스의 모든 실행, 이벤트, 산출물, 자동화 및 작업 공간 리소스를 영구 삭제합니다. 이 작업은 되돌릴 수 없습니다.',
    serviceDeleted: '“{name}” 서비스를 삭제했습니다.',
    deleteServiceFailed: '서비스를 삭제할 수 없습니다.',
    breadcrumb: '이동 경로',
    backToWorkspace: '프로젝트 워크스페이스로 돌아가기',
    projectSettings: '프로젝트 설정',
    kanban: 'Agent Board',
    kanbanRetryTitle: 'Kanban 링크를 불러올 수 없습니다. 다시 시도하세요.',
    kanbanUnavailableRetry: 'Kanban 사용 불가 · 다시 시도',
    demoTag: 'DEMO',
    noRepositoriesYet: '아직 서비스가 없습니다',
    repositoriesCount_one: '{count}개 리포지토리',
    repositoriesCount_other: '{count}개 리포지토리',
    openProvider: '{provider} 열기',
    repoUrlUnresolved: '서버가 이 제공자 리포지토리의 브라우저 URL을 확인할 수 없습니다.',
    repositoryUnavailable: '리포지토리 사용 불가',
    addRepoEmptyTitle: '서비스를 추가하여 시작',
    addRepoEmptyManage: '서비스는 프로젝트를 Git 리포지토리에 연결하고 실행 대상이 됩니다.',
    addRepoEmptyMember: '실행하려면 프로젝트 소유자가 먼저 서비스를 추가해야 합니다.',
    firstServiceEyebrow: '프로젝트 설정',
    firstServiceAction: '첫 번째 저장소 연결',
    firstServiceSetupTitle: '첫 번째 서비스 추가',
    firstServiceSetupDescription: '저장소를 선택하세요. 연결하면 작업과 자동화의 실행 대상이 됩니다.',
    source: '소스',
    directCredential: '직접 (본인 자격 증명)',
    gitProvider: 'Git 제공자',
    pickRepository: '리포지토리 선택',
    searchRepositories: '리포지토리 검색…',
    loadingRepositories: '리포지토리 불러오는 중…',
    listReposFailed: '{source} 리포지토리를 나열할 수 없습니다.',
    integrationSource: '통합',
    addRepoByUrlInstead: ' 대신 아래에서 URL로 리포지토리를 추가하세요.',
    noRepositoriesMatch: '일치하는 리포지토리가 없습니다.',
    private: '비공개',
    orAddByUrl: '또는 URL로 추가',
    repositoryName: '리포지토리 이름',
    repositoryUrl: '리포지토리 URL',
    addRepository: '리포지토리 추가',
    memberNeedsIntegration: 'Service를 추가하기 전에 GitHub, GitLab 또는 Gitea Project Plugin을 연결하고 활성화하세요.',
    configureProjectPlugins: '프로젝트 플러그인 구성',
    automationsMembersTitle: '자동화는 프로젝트 멤버가 사용할 수 있습니다',
    automationsMembersDesc: '작업 기록은 볼 수 있지만, 예약과 제공자 이벤트는 프로젝트 멤버가 관리해야 합니다.',
    automationsNeedServiceTitle: '자동화에는 서비스가 필요합니다',
    automationsNeedServiceDesc: '먼저 리포지토리를 연결하세요. 예약과 제공자 이벤트는 서비스 범위로 지정됩니다.',
  },

  plugins: {
    title: '플러그인', projectPlugin: '프로젝트 플러그인', intro: '이 프로젝트에서는 공급자를 한 번만 연결합니다. 정상이고 활성화된 플러그인은 모든 프로젝트 작업에서 사용할 수 있습니다.',
    readOnly: '프로젝트 소유자 또는 Cluster 관리자만 플러그인 연결을 변경할 수 있습니다.', loading: '플러그인 불러오는 중…', loadError: '플러그인을 불러올 수 없습니다.',
    notConnected: '연결되지 않음', connect: '연결', connectError: '공급자 연결을 시작할 수 없습니다.', summary: '서비스 {services}개 · 자동화 {automations}개',
    back: '플러그인으로 돌아가기', identity: '연결된 ID', scopes: '허용된 액세스', noScopes: '현재 허용된 공급자 액세스가 없습니다.',
    resources: '리소스', noResources: '아직 연결된 프로젝트 리소스가 없습니다.', automationSummary: '자동화', openAutomations: '자동화 열기', audit: '연결 감사',
    noAudit: '아직 기록된 감사 이벤트가 없습니다.', reconnect: '다시 연결', stableId: '안정 ID: {id}', consentRecorded: '동의 {version} · {time}', unknown: '알 수 없음',
    resourcesLoadError: '공급자 리소스를 나열할 수 없습니다.', boundWorkspace: '연결된 워크스페이스', selectWorkspace: '워크스페이스 선택…', workspaceSetupHint: '워크스페이스를 선택하면 JType 플러그인 설정이 완료되고 활성화됩니다.',
    workspace: '워크스페이스', columns: '{count}개 열', private: '비공개', public: '공개', defaultBranchUnknown: '기본 브랜치를 알 수 없음', services: '연결된 서비스',
    noServices: '이 플러그인에 연결된 서비스가 없습니다.', noAutomations: '이 플러그인에 의존하는 자동화가 없습니다.', auditLoadError: '플러그인 감사 기록을 불러올 수 없습니다.', auditLoading: '감사 기록 불러오는 중…',
    impactLoading: '영향 범위 불러오는 중…', impactLoadError: '영향 범위를 불러올 수 없습니다.', impactSummary: '서비스 {services}개와 자동화 {automations}개가 영구 삭제됩니다.',
    forceUninstall: '공급자 Webhook 정리만 실패한 경우 로컬 제거를 강제합니다. 외부 훅이 남을 수 있습니다.',
    enable: '플러그인 활성화', disable: '플러그인 비활성화', uninstall: '플러그인 제거', uninstallHint: '제거하면 외부 정리 후 종속된 서비스와 자동화가 영구 삭제됩니다.', uninstallTitle: '{provider}을(를) 제거할까요?', uninstallConfirm: '이 작업은 되돌릴 수 없습니다. 로컬 플러그인 제거 후에도 외부 Webhook 정리가 계속될 수 있습니다.', uninstallType: '확인하려면 UNINSTALL 입력', invalidProvider: '이 공급자 플러그인은 존재하지 않습니다.',
    consentTitle: '{provider} 연결', consentIntro: '계속하기 전에 이 연결이 jcode Cloud에 부여하는 프로젝트 전체 액세스를 검토하세요.', consentScope: '공급자는 이 플러그인에 필요한 코드, 브랜치, 풀 리퀘스트, Issue, 댓글, 검사, 태그, 릴리스 및 Webhook 액세스를 요청합니다.', consentShared: '토큰은 설치자의 개인 자격 증명이 아니라 프로젝트 공유 자격 증명이 됩니다.', consentTasks: '모든 프로젝트 작업은 이 플러그인을 포함해 활성화된 모든 플러그인을 받습니다.', consentPersistence: '설치자가 프로젝트를 떠난 후에도 이 연결은 연결 해제하거나 공급자가 취소할 때까지 유지됩니다.', consentPublic: '공개 리포지토리에서는 @jcode 댓글로 모든 활성 프로젝트 플러그인 자격 증명을 받는 작업이 시작될 수 있습니다.', consentAcknowledge: '이 프로젝트 전체 액세스를 이해하고 승인합니다.', continueToProvider: '공급자로 계속',
    incompleteResponse: '공급자가 불완전한 연결 응답을 반환했습니다.',
    providerInstance: '공급자 인스턴스', configuredClusterInstance: 'Cluster에 구성된 인스턴스', requestedScopes: '요청 권한 범위',
    githubChooseInstallation: 'GitHub App Installation 선택',
    githubChooseInstallationHint: '동의하기 전에 Installation을 선택하고 실제 권한을 확인하세요. 이 선택은 현재 프로젝트에만 적용되며 다른 프로젝트에 자동으로 재사용되지 않습니다.',
    githubInstallationsLoading: 'GitHub Installations 불러오는 중…', githubInstallationsLoadError: 'GitHub Installations를 나열할 수 없습니다.',
    githubInstallationSummary: '{target} · {selection} 리포지토리',
    githubTarget: { organization: '조직', user: '사용자' }, githubSelection: { selected: '선택됨', all: '전체' },
    githubInstallationsEmpty: '관리할 수 있는 GitHub App Installation이 없습니다. GitHub에서 App을 설치하거나 리포지토리 범위를 조정한 후 다시 시도하세요.',
    githubActualPermissions: '{account}의 실제 권한',
    githubPermissionsAcknowledge: '이 GitHub App의 실제 권한을 검토했으며 위의 프로젝트 전체 자격 증명 위험을 수락합니다.',
    githubConnectInstallation: '이 Installation 연결',
    jtypeApprove: 'JType에서 승인', jtypeApproveHint: '확인 코드 <code>{code}</code>을(를) 사용하세요. JType이 권한 부여를 확인할 때까지 이 대화상자가 계속 상태를 확인합니다.',
    jtypeOpenConsent: 'JType 동의 페이지 열기', jtypeStatusLoadError: 'JType 연결 상태를 확인할 수 없습니다.',
    connectionStatusLabel: '상태: {status}',
    connectionStatus: { pending: '승인 대기', complete: '완료', expired: '만료됨', denied: '거부됨', unsupported: '지원되지 않음', checkFailed: '상태를 확인할 수 없음' },
    coarseScope: {
      gitlab: 'GitLab의 광범위한 api scope는 이 플러그인이 일반적으로 필요로 하는 범위보다 넓은 API 읽기/쓰기를 허용할 수 있으며, 외부 역할이 변경할 수 있는 리포지토리 설정도 포함됩니다. jcode에는 모든 파괴적 API 호출을 기술적으로 차단하는 명령 허용 목록이 없습니다.',
      gitea: '인스턴스 버전과 외부 역할에 따라 Gitea의 광범위한 write:repository scope가 일반 작업 흐름을 넘어서는 리포지토리 설정 변경과 파괴적 작업을 허용할 수 있습니다. jcode에는 명령 허용 목록이 없습니다.',
      jtype: 'JType full scope는 Kanban 트리거뿐 아니라 선택한 클라우드 워크스페이스에서 지원되는 모든 읽기/쓰기 작업을 허용합니다.',
    },
    healthError: {
      jtypeStartFailed: 'JType 장치 인증을 시작할 수 없습니다.',
      webhookCleanupFailed: '공급자 Webhook 정리에 실패했습니다. 제거를 다시 시도하거나 외부 Webhook이 남을 수 있음을 수락하고 로컬 제거를 강제하세요.',
      runtimeCleanupFailed: '런타임 정리에 실패했습니다. Cluster가 정상화된 후 제거를 다시 시도하세요.',
      oauthRefreshFailed: 'OAuth 액세스가 만료되었고 갱신에 실패했습니다. 이 플러그인을 다시 연결하세요.',
      providerConfigChanged: 'Cluster 공급자 구성이 변경되었습니다. 이 프로젝트 플러그인을 다시 연결하세요.',
    },
    apiError: {
      githubAppNotConfigured: 'GitHub App 구성이 완료되지 않았습니다. Cluster 관리자에게 App ID, 개인 키 및 Webhook Secret 구성을 요청하세요.',
      githubIdentityRequired: '이 App Installation을 관리할 수 있는 GitHub 계정으로 로그인하세요.',
      githubInstallationForbidden: '현재 GitHub 계정은 선택한 App Installation을 관리할 수 없습니다.',
      githubAppError: 'GitHub가 선택한 App Installation을 확인할 수 없습니다. 다시 시도하세요.',
      consentScopeChanged: 'GitHub App 권한이 변경되었습니다. 현재 권한을 다시 검토하고 동의하세요.',
      providerNotConfigured: '이 공급자 플러그인이 Cluster에서 구성되거나 활성화되지 않았습니다.',
      credentialUnavailable: '플러그인 자격 증명을 사용할 수 없습니다. 플러그인을 다시 연결하세요.',
      reconnectRequired: '플러그인 구성이 변경되었거나 인증이 만료되었습니다. 플러그인을 다시 연결하세요.',
      connectExpired: '연결 요청이 만료되었습니다. 연결을 다시 시작하세요.',
      workspaceUnavailable: '현재 인증으로 선택한 JType 워크스페이스를 사용할 수 없습니다.',
      workspaceRequired: '이 플러그인을 활성화하기 전에 JType 워크스페이스를 선택하세요.',
      webhookCleanupFailed: '공급자 Webhook 정리에 실패했습니다. 제거를 다시 시도하거나 로컬 제거를 명시적으로 강제하세요.',
      runtimeCleanupFailed: '런타임 정리에 실패했습니다. Cluster가 정상화된 후 다시 시도하세요.',
      connectUnsupported: '이 공급자 연결 흐름은 아직 지원되지 않습니다.',
      encryptionUnavailable: 'Cluster 암호화 키가 구성되지 않았습니다. Cluster 관리자에게 문의하세요.',
      consentRequired: '연결하기 전에 현재 프로젝트 플러그인 동의 내용을 검토하고 승인하세요.',
      providerUnavailable: '공급자가 요청을 완료할 수 없습니다. 가용성과 권한을 확인한 후 다시 시도하세요.',
      generic: '플러그인 작업을 완료할 수 없습니다. 다시 시도하세요.',
    },
    auditEvent: {
      consent_accepted: '동의 승인', connected: '연결됨', reconnected: '다시 연결됨', reconnect_started: '다시 연결 시작',
      configuration_changed: '구성 변경됨', uninstall_cleanup_failed: '제거 정리 실패', uninstalled: '제거됨', force_uninstalled: '강제 제거됨',
    },
    status: { not_connected: '연결되지 않음', connecting: '연결 중', enabled: '활성화됨', disabled: '비활성화됨', action_required: '조치 필요', uninstalling: '제거 중', error: '오류' },
    trigger: { scm: 'SCM 이벤트', kanban: 'Kanban 열', cron: 'Cron 일정' },
    systemActor: '시스템',
  },

  automationEditor: {
    loading: '자동화 불러오는 중…', loadError: '자동화를 불러올 수 없습니다.', eyebrow: '리포지토리 자동화', createTitle: '자동화 만들기', editTitle: '자동화 편집',
    subtitle: '이 리포지토리에 하나의 강력한 형식의 트리거를 연결합니다.', viewerWarning: '뷰어는 설정을 볼 수 있지만 자동화를 저장할 수 없습니다.',
    task: '작업', name: '이름', service: '리포지토리', selectService: '리포지토리 선택…', serviceUnavailable: '리포지토리를 사용할 수 없음',
    model: '모델', selectModel: '모델 선택…', effort: '추론 강도', effortAuto: '자동', effortLow: '낮음', effortMedium: '중간', effortHigh: '높음',
    effortHint: '이 모델은 추론 강도 설정을 지원합니다.', promptTemplate: '프롬프트 템플릿',
    enabled: '활성화됨', ignoreJcode: 'jcode가 만든 이벤트 무시', trigger: '트리거', scm: 'SCM', cron: 'Cron',
    selectGitService: 'GitHub, GitLab 또는 Gitea 리포지토리를 연결하세요.', capabilitiesLoadError: '공급자 기능을 불러올 수 없습니다.',
    branchFilter: '브랜치 필터', branchPlaceholder: 'main 또는 feature/*', branchHint: '브랜치 정보가 있는 Push, PR 및 Check 이벤트에 사용할 수 있습니다.',
    pathPattern: '경로 패턴', pathHint: '선택한 모든 이벤트가 push.updated인 경우에만 사용할 수 있습니다.',
    conclusion: 'CI 결과', conclusionHint: '선택한 모든 이벤트가 check.completed인 경우에만 사용할 수 있습니다.',
    events: '이벤트', moreEvents: '추가 이벤트', thisProvider: '이 공급자', eventUnavailable: '{provider}{version}에서 지원하지 않습니다.',
    cronExpression: 'Cron 표현식', cronHint: '5개 필드 Cron 표현식을 사용합니다. 최소 간격은 서버에서 적용됩니다.',
    outputMode: '출력', outputRun: 'Run 직접 생성', outputCard: 'jtype Card 생성 후 Agent Board에서 실행',
    outputHint: 'Card 출력은 jtype 작업 항목을 유지하고 표준 Kanban 접수 및 기록 흐름을 사용합니다.',
    openBoardSettings: 'Agent Board 설정 열기',
    outputCardUnavailable: '정상 상태의 Agent Board를 연결한 후 Card 출력을 선택하세요.',
    create: '자동화 만들기', save: '자동화 저장',
    review: {
      eyebrow: 'GitHub 코드 리뷰', title: 'Pull Request 리뷰', subtitle: '팀이 새 흐름을 배우지 않아도 GitHub 네이티브 리뷰를 켤 수 있습니다.',
      defaultName: 'Pull Request 리뷰', setup: '리뷰 설정',
      automaticTitle: '기본 자동 리뷰', automaticBody: 'Pull Request가 준비될 때와 새 커밋마다 App이 리뷰합니다.',
      repeatTitle: 'GitHub에서 다시 실행', repeatBody: '이 명령을 Pull Request 댓글에 붙여 넣으세요. GitHub의 @ 자동 완성에 사용자 지정 App이 보이지 않아도 전체 명령은 동작합니다.',
      focus: '리뷰 중점 사항(선택)', focusPlaceholder: '예: 권한 경계를 특히 확인하세요.', focusHint: '정확성, 보안, 신뢰성, 데이터 손실, 회귀는 항상 확인합니다.',
      when: '리뷰 시점', readyTitle: '준비된 Pull Request', readyBody: '새 Pull Request와 Draft 해제 시 리뷰합니다.',
      updatesTitle: '새 커밋', updatesBody: 'Pull Request의 최신 커밋이 바뀌면 다시 리뷰합니다.',
      draftsTitle: 'Draft 포함', draftsBody: '보통 끄고 작성자의 첫 검토가 끝날 때까지 기다립니다.',
      create: '리뷰 켜기', save: '리뷰 설정 저장',
    },
    validation: { noPermission: '자동화를 편집할 권한이 없습니다.', required: '이름, 리포지토리, 모델 및 작업 프롬프트는 필수입니다.', eventRequired: '이 리포지토리 공급자가 지원하는 이벤트를 하나 이상 선택하세요.', cronRequired: 'Cron 표현식은 필수입니다.', cardOutputUnavailable: 'Card 출력에는 정상 상태의 Agent Board 정책이 필요합니다.' },
    apiError: {
      overlap: '선택한 SCM 이벤트 중 하나 이상을 이 리포지토리의 다른 자동화가 이미 사용하고 있습니다.',
      webhook: '자동화는 저장되었지만 공급자 Webhook을 동기화할 수 없습니다. 플러그인 연결을 확인하고 다시 시도하세요.',
      pluginUnavailable: '선택한 리포지토리 연결을 사용할 수 없거나 이 트리거를 지원하지 않습니다.',
      modelUnavailable: '선택한 모델을 이 계정에서 더 이상 사용할 수 없습니다. 다른 모델을 선택하세요.',
      modelRequired: '이 계정에 허용된 모델을 선택하세요.',
      effortUnsupported: '선택한 모델은 추론 강도를 지원하지 않습니다. 자동 또는 추론 모델을 사용하세요.',
      generic: '자동화를 저장할 수 없습니다. 다시 시도하세요.',
    },
  },

  automationExecutions: {
    loading: '자동화 불러오는 중…', loadError: '자동화를 불러오지 못했습니다.', back: '자동화 목록으로',
    cardOutput: 'Card 출력', runOutput: '직접 Run 출력', runNow: '지금 실행',
    runNowError: '실행을 접수하지 못했습니다. 재시도에도 같은 멱등성 키를 사용합니다.',
    history: '실행 기록', loadingHistory: '실행 기록 불러오는 중…', historyError: '실행 기록을 불러오지 못했습니다.',
    empty: '아직 실행 기록이 없습니다.', loadMore: '이전 실행 불러오기', select: '실행을 선택해 상세 내용을 확인하세요.',
    selected: '선택한 실행', execution: '실행', trigger: '트리거', kind: '종류',
    requested: '요청자', accountable: '책임자', notApplicable: '해당 없음', unattributed: '귀속 없음',
    output: '출력', expected: '예상', cardThenRun: 'jtype Card → Kanban Run', directRun: '직접 Run',
    actual: '실제', writeback: '기록', usage: '사용량', usageUnavailable: '사용 불가',
    filter: { all: '전체', blocked: '차단됨', running: '실행 중', terminal: '종료됨' },
    state: {
      accepted: '접수됨', ignored: '무시됨', duplicate: '중복',
      superseded: '대체됨', blocked: '차단됨', queued: '대기 중',
      running: '실행 중', terminal: '종료됨',
    },
    outcome: { succeeded: '성공', failed: '실패', canceled: '취소됨' },
    repair: {
      project_owner: '프로젝트 소유자가 이 종속성을 복구할 수 있습니다.',
      repository_owner: '리포지토리 소유자가 이 종속성을 복구할 수 있습니다.',
      cluster_admin: '클러스터 관리자가 이 종속성을 복구해야 합니다.',
      requester: '요청자가 이 종속성을 복구해야 합니다.',
    },
    title: {
      blocked: '출력 전에 차단됨', ignored: '규칙에 따라 무시됨',
      card: 'Card 출력', run: 'Run 출력',
    },
  },

  projectAutomations: {
    eyebrow: '리포지토리 자동화', title: '자동화', subtitle: '이 리포지토리에 SCM 및 예약 작업을 만듭니다. Agent Board는 리포지토리 헤더에서 구성합니다.',
    loading: '자동화 불러오는 중…', loadError: '자동화를 불러올 수 없습니다.', new: '새 자동화', noServices: '자동화를 만들기 전에 리포지토리를 연결하세요.',
    filters: '자동화 필터', all: '전체', empty: '현재 보기에 맞는 자동화가 없습니다.', edit: '편집', delete: '삭제',
    back: '자동화로 돌아가기', newTitle: '새 자동화', editTitle: '자동화 편집', name: '이름', triggerLabel: '트리거 유형',
    cron: 'Cron 표현식', action: 'SCM 이벤트', column: '트리거 열', prompt: '작업 지침', incomplete: '저장하기 전에 모든 필수 항목을 입력하세요.',
    create: '자동화 만들기', save: '변경 사항 저장', trigger: { scm: 'SCM 이벤트', kanban: 'Kanban 열', cron: 'Cron 일정' },
    enabled: '활성화됨', disabled: '비활성화됨', toggleLabel: '{name}: {status}',
    review: { turnOn: 'Pull Request 리뷰', manage: '리뷰 설정', rowSummary: 'GitHub App이 변경된 줄에 신뢰도 높은 문제를 게시합니다.', native: 'GitHub 네이티브 리뷰' },
    error: {
      modelUnavailable: '이 이벤트를 받았을 때 사용할 모델을 선택할 수 없었습니다. 계정에 모델을 허용하고, 여러 모델이 있다면 리포지토리 기본 모델을 설정하세요. 다음 성공적인 트리거에서 이 기록 오류가 지워집니다.',
      modelNotSelected: '여러 모델을 사용할 수 있지만 이 리포지토리에 기본 모델이 없습니다. 리포지토리 설정에서 하나를 선택하세요.',
      modelNotConfigured: '이 계정에 허용된 모델이 없습니다. Cluster 관리자에게 모델 권한을 요청하세요.',
      modelTemporary: '일시적인 내부 오류로 모델 구성을 읽을 수 없습니다. 트리거를 다시 실행하세요.',
      triggerUnavailable: '이 자동화의 트리거 구성을 사용할 수 없습니다. 자동화를 다시 저장하세요.',
      serviceUnavailable: '이 자동화에 연결된 리포지토리를 사용할 수 없습니다.',
      repositoryUnavailable: '이 리포지토리 연결을 사용할 수 없습니다. 공급자를 다시 연결하세요.',
      runCreateFailed: '이벤트는 일치했지만 자동화 작업을 만들 수 없습니다.',
      invalidCron: 'Cron 표현식이 유효하지 않습니다: {expression}',
      dispatchFailed: '예약 자동화가 작업을 만들 수 없습니다.',
      webhookReconcileFailed: 'SCM Webhook을 동기화할 수 없습니다. 플러그인 자격 증명과 공급자 Webhook 권한을 확인한 후 자동화를 다시 저장하세요.',
    },
  },

  projectSettings: {
    navGeneral: '일반',
    navMembers: '멤버',
    navPlugins: '플러그인',
    navModels: '모델 액세스',
    navApiKeys: 'API 키',
    envInvalidName: '“{key}”은(는) 유효한 환경 변수 이름이 아닙니다.',
    envReserved: '“{key}”은(는) 오케스트레이터에 예약되어 있어 설정할 수 없습니다.',
    projectUpdated: '프로젝트 “{name}”이(가) 업데이트되었습니다.',
    updateFailed: '프로젝트를 업데이트하지 못했습니다.',
    projectDeleted: '프로젝트 “{name}”이(가) 삭제되었습니다.',
    deleteFailed: '프로젝트를 삭제하지 못했습니다.',
    eyebrow: '프로젝트 관리',
    title: '설정',
    subtitle: '프로젝트 컨테이너를 관리합니다. 리포지토리 동작은 각 서비스 범위로 유지됩니다.',
    navAria: '프로젝트 설정 섹션',
    generalDesc: '프로젝트 ID 및 실행 가드레일.',
    projectName: '프로젝트 이름',
    projectNameHintPage: '리포지토리 브랜치와 git 모드는 서비스별로 구성됩니다.',
    executionGuardrails: '실행 가드레일',
    guardrailBlankHint: '제한을 비워 두면 Cluster 기본값을 상속합니다.',
    maxConcurrent: '최대 동시 실행 수',
    clusterDefaultPlaceholder: 'Cluster 기본값',
    runTimeout: '실행 시간 제한(초)',
    injectedEnv: '주입 환경 변수',
    injectedEnvHintPage: '모든 실행에 병합됩니다. 시스템 변수는 예약되어 있습니다.',
    removeVariable: '변수 제거',
    addVariable: '변수 추가',
    membersTitle: '멤버 및 권한',
    membersDesc: '이 프로젝트를 보고, 실행하고, 관리할 수 있는 사람을 선택하세요.',
    pluginsTitle: '플러그인',
    pluginsDesc: '프로젝트에서 공유하는 소스 제어 및 Kanban 연결.',
    modelsDesc: '현재 이 프로젝트의 세션에서 사용할 수 있는 모델.',
    apiKeysTitle: '프로젝트 API 키',
    apiKeysDesc: 'API 트리거 자동화를 위한 취소 가능한 자격 증명.',
    dangerTitle: '위험 구역',
    dangerDesc: '영구적이고 파괴적인 프로젝트 작업.',
    deleteProject: '프로젝트 삭제',
    deleteHintPage: '이 프로젝트와 모든 실행, 이벤트, 아티팩트를 영구적으로 제거합니다.',
    deleteForGood: '완전히 삭제하시겠습니까?',
    savebarHint: '프로젝트 설정은 서비스 설정과 별도로 저장됩니다.',
    saveChanges: '변경 사항 저장',
    loadingModelAccess: '모델 액세스 불러오는 중…',
    modelAccessLoadError: '모델 액세스를 불러올 수 없습니다. 프로젝트 워크스페이스에서 다시 시도하세요.',
    noModelConfigured: '이 프로젝트에 구성된 모델이 없습니다. Cluster 관리자에게 부여를 요청하세요.',
    granted: '부여됨',
    envFallbackActive: 'Cluster 환경 모델 폴백이 활성화되어 있습니다.',
    models: {
      ownedTitle: '프로젝트 모델 제공자',
      ownedDescription: '이 프로젝트 전용 제공자를 연결하고 실행할 모델을 선택합니다.',
      addProvider: '제공자 추가',
      providersSummary: '제공자 {providers}개 · 모델 {models}개',
      noProviders: '아직 프로젝트 모델 제공자가 없습니다.',
      noProvidersHint: '제공자를 추가해 이 프로젝트 전용 모델을 구성하세요.',
      enableAria: '{name} 사용',
      disableAria: '{name} 사용 중지',
      editModelAria: '{name} 편집',
      deleteModelAria: '{name} 제거',
      removeModelConfirm: '{name}을(를) 제거하시겠습니까?',
      modelRemoved: '모델이 제거되었습니다.',
      removeModelError: '모델을 제거할 수 없습니다.',
      updateModelError: '모델을 업데이트할 수 없습니다.',
      clearHeadersAction: '구성된 헤더 제거',
      clearHeadersPending: '저장 시 구성된 헤더가 제거됩니다 · 클릭하여 취소',
      editDialogTitle: '모델 편집 · {name}',
      saveModel: '모델 저장',
      modelSaved: '모델이 저장되었습니다.',
      saveModelError: '모델을 저장할 수 없습니다.',
      availableTitle: '사용 가능한 모델',
      defaultTitle: '프로젝트 기본 모델',
      defaultDescription: 'Automation 또는 Service가 더 구체적인 모델을 선택하지 않았을 때 사용합니다.',
      noDefault: '프로젝트 기본 모델 없음',
      availableOwnerHint: '이 프로젝트가 실행할 수 있는 모든 모델 — 자체 모델과 Cluster 관리자가 부여한 모델을 포함합니다.',
      availableMemberHint: 'Cluster 관리자 또는 프로젝트 소유자가 이 프로젝트에 제공한 모델입니다.',
    },
    name: '이름',
    guardrails: '가드레일',
    apiKeyCreated: 'API 키 “{name}”이(가) 생성되었습니다.',
    apiKeyCreateFailed: 'API 키를 생성할 수 없습니다.',
    apiKeyRevoked: 'API 키가 취소되었습니다.',
    apiKeyRevokeFailed: 'API 키를 취소할 수 없습니다.',
    apiKeyIntro1: '프로젝트 범위 키는 ',
    apiKeyIntro2: '(으)로 인증하며 이 프로젝트에서만 실행을 트리거하고 읽을 수 있습니다 — 다른 프로젝트, 이 프로젝트의 설정이나 멤버, Cluster 관리자 영역에는 절대 접근할 수 없습니다. Cluster 전역 콘솔 토큰 대신 외부/CI 자동화에 사용하세요.',
    apiKeysEmpty: '아직 API 키가 없습니다 — 아래에서 하나 생성하세요.',
    apiKeyNameHint: '나중에 키를 구분하는 데 도움이 됩니다 — 이 키를 사용할 CI 작업처럼 식별 가능한 이름을 선택하세요.',
    createKey: '키 만들기',
    apiKeyRevealTitle: '“{name}” 생성됨',
    apiKeyRevealHint: '한 번만 표시됩니다 — 지금 복사하세요. 다시 표시할 수 없으며, 분실하면 이 키를 취소하고 새로 생성해야 합니다.',
    statusRevoked: '취소됨',
    statusActive: '활성',
    createdAt: '생성 {time}',
    lastUsed: ' · 마지막 사용 {time}',
    neverUsed: ' · 사용 안 함',
    revoke: '취소',
  },

  projectWorkspace: {
    railServicesAria: '프로젝트 서비스',
    projectEyebrow: '프로젝트',
    serviceCount_one: '{count}개 서비스',
    serviceCount_other: '{count}개 서비스',
    servicesHeading: '서비스',
    noServiceConnected: '아직 연결된 서비스가 없습니다.',
    workspaceAria: '{projectName} 워크스페이스',
    tabsAria: '프로젝트 워크스페이스 섹션',
    tabTasks: '작업',
    tabAutomations: '자동화',
    tabServiceSettings: '서비스 설정',
  },

  taskComposer: {
    eyebrow: '새 작업',
    heading: '{name}에서 세션 시작',
    isolation: '격리된 워크스페이스에서 실행됩니다',
    messageAria: '메시지',
    placeholder: '완료할 작업을 설명하세요…',
    permissionModeAria: '권한 모드',
    permissionModeTitle: '전체 액세스는 에이전트를 자동 승인합니다. 작업 전 확인은 타임라인에서 승인할 때까지 에이전트를 일시 중지합니다.',
    fullAccess: '전체 액세스',
    askBeforeActions: '작업 전 확인',
    session: '세션',
    modelAria: '모델',
    serviceDefault: 'Repository 기본값',
    serviceDefaultWithModel: 'Repository 기본값 · {model}',
    branchAria: '기준 브랜치',
    branchDefault: '기본값',
	branchLoading: '브랜치를 불러오는 중…',
    branchUnavailable: '브랜치를 새로 고칠 수 없습니다. Plugin 연결을 복구한 뒤 다시 시도하세요.',
    effortAria: '추론 강도',
    effortAuto: '추론 · 자동',
    effortLow: '추론 · 낮음',
    effortMedium: '추론 · 중간',
    effortHigh: '추론 · 높음',
    add: '추가',
    addMenu: '작업에 추가',
    goalMode: 'Goal 모드',
    goalPlaceholder: '계속 달성할 목표를 설명하세요…',
    goalModeHint: '다음 작업을 지속형 Goal로 시작합니다.',
    disableGoalMode: 'Goal 모드 끄기',
    attachments: '첨부 파일',
    addAttachments: '첨부 파일 추가',
    removeAttachment: '{name} 삭제',
    attachmentTooMany: '첨부 파일은 최대 {max}개까지 추가할 수 있습니다.',
    attachmentTooLarge: '{name} 파일이 25 MiB를 초과합니다.',
    attachmentTotalTooLarge: '실행당 첨부 파일 총 크기는 최대 {max} MiB입니다.',
    attachmentUploadFailed: '첨부 파일을 업로드할 수 없습니다.',
    send: '보내기',
  },


  settingsPanel: {
    emptyTitle: '설정에는 Repository가 필요합니다',
    emptyDescription: '모델 정책을 구성하기 전에 리포지토리를 연결하세요.',
    eyebrow: 'Repository 설정',
    description: '이 Repository의 실행 정책입니다. 제공자 연결은 별도로 관리됩니다.',
    source: '소스',
    provider: '제공자',
    defaultBranch: '기본 브랜치',
    gitMode: 'Git 모드',
    gitModeDraftPr: '초안 풀 리퀘스트',
    gitModeReadOnly: '읽기 전용',
    modelPolicyEyebrow: '모델 정책',
    modelPolicyTitle: 'Repository 기본 모델',
    modelPolicyDescription: '작업 작성기에서 실행별 선택을 Repository 기본값으로 유지할 때만 사용됩니다.',
    modelsLoading: '계정 모델 권한 불러오는 중…',
    modelsUnverified: '이 계정의 모델 권한을 검증할 수 없습니다. 모델 카탈로그를 사용할 수 있을 때까지 기본값을 변경하지 마세요.',
    retryModelCheck: '모델 확인 다시 시도',
    defaultModelAria: '이 리포지토리의 기본 모델',
    noDefault: '기본값 없음',
    noModelGranted: '이 계정에 허용된 모델이 없습니다. Repository 기본값을 선택하려면 먼저 Cluster 관리자가 모델을 허용해야 합니다.',
	runtimePolicyEyebrow: '런타임 정책',
	runtimePolicyTitle: 'Runner 환경',
	runtimePolicyDescription: '이 Repository의 각 Run에 관리자가 유지하는 불변 도구 체인 환경을 선택합니다.',
	runnerProfileAria: '이 리포지토리의 Runner 환경',
	runtimeProfilesUnavailable: '런타임 프로필을 불러올 수 없습니다. 현재 설정은 변경되지 않습니다.',
  },

  webhook: {
    errSync: '제공자 Webhook을 동기화할 수 없습니다. 다시 시도하거나 Cluster 관리자에게 문의하세요.',
    eyebrowReview: 'PR 리뷰 Webhook',
    unavailableTitle: '제공자 이벤트에는 제공자 기반 리포지토리가 필요합니다',
    pathOrUrlNote: '은(는) 경로 또는 원시 URL이므로 풀 리퀘스트 또는 병합 리퀘스트 댓글 이벤트를 받을 수 없습니다.',
    readonlyTitle: '자동화는 뷰어에게 읽기 전용입니다',
    readonlyBody: '프로젝트 멤버는 {provider}을(를) 연결하고 이 리포지토리의 리뷰 Webhook을 동기화할 수 있습니다.',
    oauthNotConfiguredTitle: '이 Cluster에 {provider} OAuth가 구성되어 있지 않습니다',
    oauthNotConfiguredBody: 'Cluster 관리자에게 {provider} OAuth와 Webhook 수신기 구성을 요청하세요. 폴백 자격 증명은 사용되지 않습니다.',
    serviceTitle: '로그인한 프로젝트 멤버가 {provider}을(를) 승인해야 합니다',
    serviceBody: '콘솔 토큰 세션에는 개인 OAuth ID가 없습니다. 이 Webhook을 동기화하려면 프로젝트 멤버 계정으로 로그인하세요.',
    eyebrowProvider: '제공자 Webhook',
    connectTitle: 'PR 리뷰 명령을 위해 {provider} 연결',
    connectBodyPre: '다음을 관리하는 계정을 연결하세요:',
    connectBodyPost: '. jcode가 이 리포지토리에 대한 OAuth 권한을 요청합니다. 여기에 개인 액세스 토큰을 붙여넣도록 요구하지 않습니다.',
    connectCta: 'OAuth로 {provider} 연결',
    readyTitle: '{provider} PR 리뷰 명령',
    readyBodyPre: '동기화는 다음에 대해 제공자의 댓글 Webhook을 등록합니다:',
    readyBodyMid: ' {provider} OAuth 계정을 사용합니다. 그러면 공동 작업자가 다음으로 리뷰를 시작할 수 있습니다: ',
    readyBodyPost: '. 리포지토리가 변경되면 다시 실행해도 안전합니다.',
    oauthConnected: 'OAuth가 연결되었습니다.',
    synchronizing: 'Webhook 동기화 중…',
    setupReady: 'Webhook 설정이 준비되었습니다.',
    syncedTo: 'Webhook이 다음에 동기화됨:',
    syncButton: '{provider} Webhook 동기화',
    reconnectOauth: 'OAuth 다시 연결',
  },

  runActivity: {
    eyebrow: '활동',
    title: '최근 작업',
    filtersAria: '최근 작업 필터링',
    filterAll: '전체',
    filterSessions: '세션',
    filterReviews: '리뷰',
    loadingTasks: '작업 불러오는 중…',
    errorTitle: '작업을 불러올 수 없습니다',
    emptyTitleAll: '아직 작업이 없습니다',
    emptyTitleFiltered: '이 Repository에 {filter}이(가) 없습니다',
    emptyDescDispatch: '위의 작성기를 사용하여 첫 작업을 디스패치하세요.',
    emptyDescNone: '이 프로젝트에 아직 디스패치된 작업이 없습니다.',
    emptyDescFiltered: '다른 필터를 시도하거나 다른 Repository를 선택하세요.',
    runAria: '{kind}: {summary} — {status}',
    retryTitle: '이전 실행의 재시도',
    retryBadge: '재시도',
  },

  projectSettingsAction: {
    label: '프로젝트 설정',
  },

  codeReviewsPage: { eyebrow: '독립 워크플로', title: 'Code reviews', description: 'Repository 전체의 Review Run을 구현 작업과 분리해 표시합니다.', createEyebrow: '새 리뷰', createTitle: 'Code review 시작', createDescription: 'Repository와 완료된 Cloud 작업이 만든 Pull request를 선택합니다.', loadingSources: '리뷰 가능한 Pull request를 불러오는 중…', sourcesError: '리뷰 가능한 Pull request를 불러올 수 없습니다.', noRepositories: '이 계정에서 사용할 수 있는 Repository가 없습니다.', connectRepository: 'Git 계정 접근 확인', repositoryLabel: 'Repository', pullRequestLabel: 'Pull request', noReviewablePr: '리뷰할 수 있는 Cloud Pull request가 없습니다.', noReviewablePrDescription: 'Pull request를 여는 Repository 작업을 실행한 뒤 돌아오세요.', openWorkHome: 'Work Home 열기', openPullRequest: 'Pull request 열기', createAction: 'Code review 만들기', createSuccess: 'Code review가 시작되었습니다.', createError: 'Code review를 시작할 수 없습니다.', emptyTitle: '아직 Code review가 없습니다', emptyDescription: '각 Repository의 Review Run이 여기에 표시됩니다.' },
  accountHeader: {
    location: '작업 공간 위치',
    account: '계정', menu: '계정 메뉴', codeReviews: '코드 리뷰', settings: '계정 설정', clusterSettings: '클러스터 설정', admin: '관리자', signOut: '로그아웃',
  },
  accountSettings: {
    back: '작업 홈으로 돌아가기', eyebrow: '계정', title: '계정 설정',
    description: '프로필, 모델 접근, 연결된 Git 계정, 사용량 및 환경 설정은 모든 Repository와 jcode Desktop에 적용됩니다.',
    tabsAria: '계정 설정 섹션', profileTab: '프로필', gitAccountsTab: 'Git 계정', modelsTab: '모델', usageTab: '사용량', preferencesTab: '환경 설정',
    profileTitle: '계정 프로필', profileDescription: 'Repository 작업을 실행하고 대화를 소유하는 데 사용하는 ID입니다.',
    displayName: '표시 이름', accountId: '계정 ID', role: '역할', clusterAdministrator: '클러스터 관리자', member: '멤버', executionIdentity: '실행 ID',
    repositoryOwnerDefault: '기본 Repository owner', currentAccount: '현재 계정', sessionAccount: '세션 계정',
    gitAccountsTitle: 'Git 계정', gitAccountsDescription: '연결된 계정에서 볼 수 있는 Repository가 Work Home의 컨텍스트 선택기에 바로 표시됩니다.',
    repositoryAccessUnavailable: '이 계정에서는 Repository에 접근할 수 없습니다.', connected: '이 계정에 연결됨', reauthorize: '{provider} 재인증', linkProvider: '{provider} 연결',
    authorizeRepositories: '이 계정의 Repository 인증', checkingRepositoryAccess: 'Repository 접근 확인 중…', repositoryAccessUnavailableTitle: 'Repository 접근을 사용할 수 없음',
    modelsTitle: '모델 및 공급자', modelsDescription: '모델은 사용자에게 직접 인증되며 모든 Repository에 적용됩니다.', loadingModels: '계정 모델 불러오는 중…', modelAccessUnavailable: '모델 접근을 사용할 수 없음',
    noModels: '계정에 인증된 모델이 없습니다. 클러스터 관리자에게 문의하세요.', modelAuthorized: '계정에 인증됨', manageAuthorizations: '클러스터 설정에서 계정 인증 관리',
    preferencesTitle: '환경 설정', preferencesDescription: '지원되는 범위에서 Cloud와 Desktop은 동일한 언어와 표시 설정을 사용합니다.',
    language: '언어', languageDescription: '인터페이스 언어를 변경합니다.', appearance: '화면 모드', appearanceDescription: '라이트 또는 다크 테마를 사용합니다.',
  },
  repositories: {
    openRepository: '리포지토리 {name} 열기',
    toggleConversations: '{name} 대화 펼치기 또는 접기',
    conversationSection: '대화',
    navigationUnavailable: '이 리포지토리를 사용할 수 없습니다. Git 계정 권한을 확인하거나 다른 리포지토리를 선택하세요.',
    remoteUnavailable: '이 원격 기기를 사용할 수 없습니다. 다시 연결하거나 다른 기기를 선택하세요.',

    eyebrow: '내 코드', title: 'Repositories',
    description: 'Repository 하나가 Board, 작업, 설정, Code reviews를 가진 Agent 작업 공간 하나입니다.',
    composerEyebrow: '계정 작업 공간', composerTitle: '다음에는 무엇을 코딩할까요?',
    composerDescription: '연결된 계정으로 접근 가능한 저장소를 선택하고 바로 작업을 시작하세요.',
    remoteComposerDescription: '온라인 jcode 기기에서 같은 대화 UI로 작업을 계속합니다.',
    contextAria: 'Repository 또는 Remote 컨텍스트 {context}', repositoryFallback: 'Repository', remoteBack: 'Repositories로 돌아가기', remoteConnection: '원격 연결',
    remoteChooseDevice: '온라인 jcode 기기 선택', onlineDevices: '온라인 기기', jcodeDevice: 'jcode 기기', online: '온라인',
    connectNewDevice: '새 기기 연결', connectNewDeviceDescription: 'jcode login을 실행하고 암호화 페어링 완료',
    pickerSearchAria: 'Repositories 검색', pickerSearchPlaceholder: 'Repositories 검색…', gitRepositories: 'Git 저장소',
    pickerSearchError: 'Repository 검색에 실패했습니다. 검색어를 바꾸거나 다시 시도하세요.', pickerNoMatch: '“{query}”와 일치하는 Repository가 없습니다.',
    remoteConnectionAria: '원격 연결, {count}대 온라인', remoteOnlineCount: 'jcode 기기 {count}대 온라인', searchingRepositories: 'Repositories 검색 중',
    conversationRailAria: '대화', conversationRailWorkHome: '워크 홈', conversationRailNew: '새 대화',
    conversationRailSearchAria: '대화 검색', conversationRailSearchPlaceholder: '대화 검색…', conversationRailByRepository: '최근 리포지토리',
    conversationRailCollapse: '대화 패널 접기', conversationRailExpand: '대화 패널 펼치기', conversationRailEmptyTitle: '아직 대화가 없습니다',
    conversationRailEmptyDescription: '작업을 시작하면 첫 대화가 생성됩니다.', conversationRailNoMatch: '검색과 일치하는 대화가 없습니다.', conversationRailRepositoryUnavailable: 'Repository를 사용할 수 없습니다',
    workspaceTasks: '작업', workspaceBoard: '보드', workspaceReviews: '코드 리뷰', workspaceAutomations: '자동화', workspaceUsage: '사용량', workspaceSettings: '설정',
    cloudRunner: '클라우드 Runner', noTasksTitle: '이 Repository에 작업이 없습니다', noTasksDescription: '위에서 작업을 설명해 첫 대화를 시작하세요.',
    boardDescription: '기존 Board를 연결하고 Card에서 이 Repository의 Agent를 시작합니다.', reviewsDescription: '이 Repository의 독립 코드 리뷰 Run입니다.',
    reviewsEmptyDescription: '구현 작업과 섞이지 않도록 별도 리뷰를 만드세요.', boardNotConnected: 'Board가 연결되지 않음',
    boardNotConnectedDescription: '준비되면 기존 Board를 연결할 수 있습니다. Repository 워크스페이스는 이미 사용할 수 있습니다.', boardWorkflowAria: '기본 Agent Board 워크플로',
    boardBacklog: '백로그', boardBacklogDescription: '작업을 기다리는 Card', boardAgentQueue: 'Agent 대기열', boardAgentQueueDescription: 'jcode를 시작하는 Card',
    boardDoneOptional: '완료(선택)', boardDoneDescription: '성공한 결과',
    attachmentsAfterConversation: '이 Repository에 활성 대화가 생기면 첨부 파일을 추가할 수 있습니다.', modeCeilingHint: 'Cloud 작업은 승인, 계획 및 자동 모드를 지원합니다.',
    baseBranchAria: '기준 브랜치 {branch}', unavailable: '사용할 수 없음', loadingBranches: '브랜치 불러오는 중…', branchUnavailable: '브랜치를 사용할 수 없음',
    startingRepositoryTask: 'Repository 작업 시작 중…', branchesUnavailable: 'Repository 브랜치를 사용할 수 없습니다.', noToolModel: '계정에 인증된 모델 중 Agent 도구 호출을 지원하는 모델이 없습니다.',
    remoteSetup: 'Remote 설정', deviceOffline: '이 기기는 오프라인입니다. 기기에서 jcode를 연 뒤 다시 시도하세요.', startingConversation: '새 대화 시작 중',
    deviceSlow: '기기 응답이 예상보다 오래 걸립니다…', creatingOnDevice: '기기에서 생성 중…',
    taskAria: '작업 설명', taskPlaceholder: '작업을 설명하세요…', repositoryAria: 'Repository',
    accountLoading: '저장소 불러오는 중…', chooseAccountRepository: '저장소 선택',
    modelsLoading: '모델 불러오는 중…', modelRequired: '모델 선택', startTask: '작업 시작',
    startFailed: '작업을 시작할 수 없습니다.', accountLoadError: '계정 저장소를 불러올 수 없습니다. 제공자 계정을 다시 연결하세요.',
    linkAccount: 'Git 제공자 계정을 연결하면 저장소를 선택할 수 있습니다.', reviewGitAccountAccess: 'Git 계정 권한 확인',
    authorizeModel: '관리자에게 계정 모델 승인을 요청하세요.', reviewModelAccess: '모델 권한 확인',
    detailsTitle: 'Repository 세부 정보', detailsDescription: '사용한 Repository의 설정, Agent Board, 작업 기록을 엽니다.',
    noDetails: '첫 작업을 시작하면 세부 정보가 표시됩니다. 사전 연결 단계는 필요 없습니다.',
    connect: 'Repository 연결', loading: 'Repositories 불러오는 중…', loadError: 'Repositories를 불러올 수 없습니다',
    preparing: 'Repository 작업 공간 준비 중…', prepareError: 'Repository 작업 공간을 준비할 수 없습니다',
    connectionsTitle: '제공자 계정', connectionsDescription: '계정 제공자와 JType 접근을 관리합니다. Repository는 별도 연결이 필요하지 않습니다.',
    chooseRepository: 'Repository 선택',
    emptyEyebrow: '코드에서 시작', emptyTitle: '첫 Repository 연결',
    emptyBody: 'Repository를 선택해 Agent 작업 공간을 만듭니다. 개인 작업 공간은 표시하지 않습니다.',
    listTitle: '연결된 Repositories', visible: '개 표시', search: 'Repositories 검색',
    searchPlaceholder: 'owner 또는 repository 검색…', noMatch: '일치하는 Repository가 없습니다.',
    details: 'Repository 세부 정보', open: '열기', codeReviews: '코드 리뷰',
    loadingOne: 'Repository 불러오는 중…', loadOneError: 'Repository를 불러올 수 없습니다', railAria: 'Repositories', noneConnected: '연결된 Repository가 없습니다.',
    workspaceAria: '{repositoryName} Repository 작업 공간', tabsAria: 'Repository 작업 공간 섹션', tabSettings: 'Repository 설정', connection: '제공자 연결',
    connectionsIntro: '각 제공자를 Repositories에 한 번만 연결합니다. 정상 연결은 Repository 작업에서 사용할 수 있습니다.', connectionsReadOnly: 'Repository owner 또는 Cluster 관리자만 제공자 연결을 변경할 수 있습니다.',
    connectionSummary: 'Repositories {repositories}개 · 자동화 {automations}개', providerRequired: 'Repository를 선택하기 전에 GitHub, GitLab 또는 Gitea 제공자를 연결하고 활성화하세요.', configureConnections: '제공자 연결 구성',
    disconnect: 'Repository 연결 해제', disconnectAria: '{name} Repository 연결 해제', disconnectConfirm: '“{name}” 연결을 해제할까요? 활성 작업을 먼저 중지한 다음 이 Repository의 Run, 이벤트, 산출물, 자동화 및 작업 공간 리소스를 영구 삭제합니다. 이 작업은 되돌릴 수 없습니다.', disconnected: 'Repository “{name}” 연결을 해제했습니다.', disconnectFailed: 'Repository 연결을 해제할 수 없습니다.',
    consentIntro: '{provider}로 계속하기 전에 이 연결이 jcode Cloud에 부여하는 계정 전체 접근 권한을 확인하세요.', consentShared: '토큰은 Repositories의 공유 자격 증명이 되며 설치한 개인에게 속하지 않습니다.', consentTasks: 'Repository 작업은 이 연결을 포함하여 활성화된 모든 제공자 연결을 사용할 수 있습니다.', consentPersistence: '이 연결은 해제되거나 제공자에 의해 취소될 때까지 유지됩니다.', consentPublic: '공개 저장소에서는 @jcode 댓글로 활성화된 제공자 자격 증명을 사용하는 작업을 시작할 수 있습니다.', consentAcknowledge: '이 계정 전체 Repository 접근 권한을 이해하고 승인합니다.',
  },
  projects: {
    noServicesConnected: '연결된 서비스 없음',
    serviceCount_one: '{count}개 서비스',
    serviceCount_other: '{count}개 서비스',
    eyebrow: '내 워크스페이스',
    title: '프로젝트',
    description: '프로젝트는 하나의 제품을 출시하는 사람, 서비스, 모델 액세스, 자동화 정책을 묶습니다.',
    newProject: '새 프로젝트',
    loadingProjects: '프로젝트 불러오는 중…',
    loadError: '프로젝트를 불러올 수 없습니다',
    empty: {
      eyebrow: '경계에서 시작하세요',
      title: '아직 프로젝트가 없습니다.',
      body: '첫 프로젝트를 빈 컨테이너로 만드세요. 다음 화면에서 사용할 수 없는 제공자가 연결된 것처럼 가장하지 않고 리포지토리를 서비스로 승인할 수 있습니다.',
      cta: '첫 프로젝트 만들기',
    },
    listTitle: '모든 프로젝트',
    visible: '표시됨',
    searchProjects: '프로젝트 검색',
    searchPlaceholder: '이름 또는 서비스 검색…',
    updatedJustNow: '방금 업데이트됨',
    searchEmptyTitle: '일치하는 프로젝트가 없습니다.',
    searchEmptyBody: '프로젝트, 서비스, 또는 리포지토리 이름을 시도하세요.',
    createdAt: '생성 {time}',
    openWorkspace: '워크스페이스 열기',
    guide: {
      eyebrow: '프로젝트 작동 방식',
      title: '소유권은 넓게, 실행은 명시적으로.',
      body: '프로젝트는 오래 유지되는 경계이며, 각 리포지토리는 자체 모델과 자동화 연결을 가진 서비스가 됩니다.',
      step1Title: '경계 만들기',
      step1Desc: '제품 또는 팀 이름을 지정하세요.',
      step2Title: '서비스 추가',
      step2Desc: '리포지토리를 명시적으로 승인하세요.',
      step3Title: '작업 시작',
      step3Desc: '종속성이 준비된 후에만.',
    },
    create: {
      nameRequired: '이름은 필수입니다.',
      created: '프로젝트 “{name}”이(가) 생성되었습니다.',
      createFailed: '프로젝트를 만들지 못했습니다.',
      submit: '프로젝트 만들기',
      nameLabel: '이름',
      namePlaceholder: 'demo',
      nameHint: '다음에 프로젝트 페이지에서 리포지토리를 추가합니다.',
    },
    new: {
      nameRequired: '이름은 필수입니다.',
      created: '프로젝트가 생성되었습니다.',
      createFailed: '프로젝트를 만들 수 없습니다.',
      heading: '프로젝트 만들기',
      subheading: '소유권 경계에서 시작하세요. 서비스는 다음입니다.',
      draft: '초안',
      step1Eyebrow: '01 / ID',
      section1Title: '프로젝트 세부 정보',
      section1Body: '사람들이 알아볼 수 있는 제품 또는 팀 경계를 사용하세요.',
      nameLabel: '이름',
      namePlaceholder: '예: jcode Cloud',
      nameHint: '서비스 URL을 변경하지 않고 나중에 프로젝트 이름을 변경할 수 있습니다.',
      step2Eyebrow: '02 / 경계',
      section2Title: '여기에 속하는 것',
      section2Body: '리포지토리는 생성 후 서비스로 추가됩니다.',
      calloutStrong: '아직 생성되거나 연결된 리포지토리가 없습니다.',
      calloutBody: '생성된 워크스페이스는 비어 있는 상태로 열리며, 소유자가 각 서비스를 명시적으로 승인합니다.',
      submit: '프로젝트 만들기',
      asideEyebrow: '생성 후',
      asideTitle: '워크스페이스가 비어 있는 상태로 열립니다.',
      asideBody: '이렇게 하면 프로젝트 생성이 정직해집니다: Git 제공자나 모델을 아직 사용할 수 없어도 컨테이너가 존재할 수 있습니다.',
      asideItem1: '리포지토리를 서비스로 연결하세요.',
      asideItem2: 'Cluster 관리자가 부여한 모델을 검토하세요.',
      asideItem3: '필요한 종속성이 구성된 후에만 작업을 시작하세요.',
    },
  },

  usage: {
    title: '사용량',
    disclaimer: '사용량은 운영 텔레메트리이며 제공업체 청구서가 아닙니다.',
    accountTitle: '클라우드 모델 사용량',
    accountDescription: '이 계정의 기기에서 발생한 모델 사용량입니다.',
    proxyOnly: 'Cloud Model Proxy를 통해 전송된 요청만 포함됩니다.',
    unavailable: '사용 불가',
    reasonNotReported: '공급자가 이 요청의 사용량을 보고하지 않았습니다.',
    reasonNoRequests: '이 기간에 사용량이 발생한 요청이 없습니다.',
    reasonParseError: 'Cloud가 공급자 사용량 데이터를 해석하지 못했습니다.',
    input: '입력',
    output: '출력',
    cacheRead: '캐시 읽기',
    cacheWrite: '캐시 쓰기',
    captured: '{captured} / {requests} 캡처',
    captureReported: '보고됨',
    captureIncomplete: '캡처 불완전',
    reported: '보고됨',
    estimated: '추정',
    uncosted: '가격 미설정',
    details: '가격 및 캡처 세부 정보',
    requests: '요청',
    reportedCapture: '전체 캡처',
    partialCapture: '부분 캡처',
    unavailableCapture: '사용 불가',
    parseErrors: '파싱 오류',
    pricingRevisions: '가격 리비전',
    none: '없음',
    pricing: '가격',
    pricingTitle: '{model} 가격',
    pricingImmutable: '가격 리비전은 변경할 수 없습니다. 변경하려면 새 유효 리비전을 추가하세요.',
    addPricingRevision: '리비전 추가',
    currency: '통화',
    effectiveAt: '적용 시각',
    inputRate: '입력 / 백만 token',
    outputRate: '출력 / 백만 token',
    cacheReadRate: '캐시 읽기 / 백만 token',
    cacheWriteRate: '캐시 쓰기 / 백만 token',
    pricingHistory: '리비전 기록',
    loadingPricing: '가격 로드 중…',
    pricingLoadError: '가격을 불러올 수 없음',
    noPricingRevisions: '가격 리비전이 없습니다. 공급자 보고가 없으면 가격 미설정으로 유지됩니다.',
    pricingValidation: '유효한 통화, 적용 시각, 하나 이상의 음수가 아닌 요금을 입력하세요.',
    pricingCreateError: '가격 리비전을 만들 수 없음',
    loading: '사용량 로드 중…',
    loadError: '사용량을 불러올 수 없음',
    groupBy: '그룹',
    group: { service: '리포지토리', automation: '자동화', model: '모델', device: '기기', grant: '권한 범위' },
    range: '기간',
    range24h: '24시간',
    range7: '7일',
    range30: '30일',
    range90: '90일',
    windowNote: '{timeZone} 기준 {range}을 표시합니다. 집계는 UTC 시간 단위 버킷을 사용합니다.',
    captureHealth: '캡처 상태',
    costSources: '비용 출처',
    reportedHelp: '공급자가 반환한 값이며 Cloud 추정치와 합산하지 않습니다.',
    estimatedHelp: '변경할 수 없는 가격 리비전으로 계산합니다.',
    uncostedHelp: '해당 카테고리 요금이 없는 token입니다.',
    groupedUsage: '{group}별 사용량',
    noGroups: '이 기간에 귀속된 사용량이 없습니다.',
    category: {
      input: '입력',
      output: '출력',
      cache_read: '캐시 읽기',
      cache_write: '캐시 쓰기',
    },
  },
  runDetail: {
    loadingRun: '실행 불러오는 중…',
    loadRunError: '실행을 불러올 수 없습니다',
    loadingWorkspace: '프로젝트 워크스페이스 불러오는 중…',
    projectName: '프로젝트 {id}',
    nav: {
      projects: '프로젝트',
      repositories: '저장소',
    },
    railFooter: '프로젝트 워크스페이스',
    repositoryWorkspace: '저장소 작업 공간',
    breadcrumbLabel: '이동 경로',
    breadcrumb: {
      tasks: '작업',
      detail: '상세',
    },
    recentTasks: '최근 작업',
    serviceUnavailable: '리포지토리 사용 불가',
    repositoryUnavailable: '저장소 사용 불가',
    noChangesBadge: '변경 없음',
    action: {
      stop: '중지',
      retry: '재시도',
      retryOtherModel: '모델 전환',
      conversation: '대화',
    },
    retryModel: {
      title: '다른 모델로 재시도',
      description: '다른 모델로 새 시도를 시작합니다. 워크플로, 코드 리비전, 권한, 전달 계약은 변경되지 않습니다.',
      current: '현재 모델',
      choose: '다른 계정 모델 선택',
      unknown: '알 수 없는 모델',
      confirm: '모델을 전환하고 재시도',
	  originalUnavailable: '원래 모델을 더 이상 사용할 수 없습니다. 다른 계정 모델을 선택하세요.',
    },
    you: '나',
    reviewInProgress: '리뷰 진행 중…',
    reviewFailed: '이 리뷰가 실패하여 출력이 생성되지 않았습니다.',
    noReviewOutput: '리뷰 출력이 생성되지 않았습니다.',
    noEvents: '기록된 대화 이벤트가 없습니다.',
    waitingForAgent: '에이전트를 기다리는 중…',
    streamDisconnected: '실시간 업데이트 연결이 끊겼습니다. 주기적 새로고침을 표시합니다.',
    reconnect: '다시 연결',
    refreshError: '최신 실행 세부 정보를 새로고침할 수 없습니다 — 마지막으로 알려진 상태를 표시합니다.',
    modelLabel: '모델',
    toast: {
      permissionDecisionFailed: '권한 결정을 보낼 수 없습니다.',
      messageFailed: '메시지를 보낼 수 없습니다.',
      sessionResumed: '세션이 재개되었습니다.',
      resumeFailed: '세션을 재개할 수 없습니다.',
      canceled: '실행이 취소되었습니다.',
      cancelFailed: '취소에 실패했습니다.',
      retryDispatched: '재시도가 디스패치되었습니다.',
      retryFailed: '재시도에 실패했습니다.',
      sessionFinishing: '세션 종료 중 — 에이전트가 마무리하고 있습니다.',
      finishFailed: '세션을 종료할 수 없습니다.',
    },
    failure: {
      cloneFailed: '리포지토리 복제 실패',
      setupFailed: '프로젝트 설정 실패',
      agentError: '에이전트 오류',
      modelRateLimited: '모델 속도 제한',
      timeout: '시간 초과',
      pushFailed: '브랜치 푸시 실패',
      runFailed: '실행 실패',
      noMessage: '실행이 메시지 없이 실패했습니다.',
    },
    kind: {
      codeReview: '코드 리뷰',
      session: '세션',
      automatedTask: '자동화 작업',
      manualTask: '수동 작업',
    },
    originLabel: {
      webhook: '제공자 Webhook',
      schedule: '예약',
      kanban: '칸반',
      prEvent: 'PR 이벤트',
      manual: '수동',
    },
    session: {
      sessionQueued: '세션 대기 중 — 여유 동시 실행 슬롯을 기다리는 중입니다.',
      sessionStarting: '세션 시작 중 — 워크스페이스를 스케줄링하고 있습니다.',
      sessionActionsHint: '종료는 현재 턴이 끝난 후 에이전트가 마무리하도록 합니다. 취소는 즉시 중지합니다.',
      finishSession: '세션 종료',
      resumeHint: '이 세션을 계속합니다 — 에이전트가 동일한 컨텍스트를 유지합니다.',
    },
    composer: {
      continuePlaceholder: '이 작업을 계속하세요…',
      followUpPlaceholder: '후속 작업을 대기열에 추가하세요 — 현재 턴 이후에 실행됩니다…',
      serviceDefault: '리포지토리 기본값',
      useServiceModel: '리포지토리에 구성된 모델 사용',
      modelFixed: '이 활성 세션에서는 모델이 고정됩니다',
      messageInput: '메시지 입력',
      attachmentsUnavailableTitle: '첨부 파일은 아직 Cloud 세션에서 사용할 수 없습니다.',
      attachmentsUnavailable: '첨부 파일 사용 불가',
      modelAccessLocked: '모델과 액세스는 재개할 때 적용됩니다.',
      modeCeilingHint: 'Cloud 세션은 승인, 계획, 자동 모드를 지원합니다.',
      queue: '대기열',
      send: '보내기',
      sendMessage: '메시지 보내기',
    },
    model: {
      disabledTitle: '활성 에이전트 세션은 기존 모델을 유지합니다.',
      chooseTitle: '재개된 세션의 모델을 선택하세요.',
      filterModels: '모델 필터링',
      filterModelsPlaceholder: '모델 필터링…',
      modelsHeading: '모델',
      noMatchingModels: '일치하는 모델이 없습니다',
    },
    permission: {
      askForApproval: '승인 요청',
      askForApprovalSub: '에이전트가 도구를 실행하기 전에 확인합니다',
      plan: '계획',
      planSub: '아직 Cloud 세션에서 사용할 수 없습니다',
      fullAccess: '전체 액세스',
      fullAccessSub: '에이전트가 확인 없이 작업할 수 있습니다',
      permissionMode: '권한 모드',
      disabledTitle: '활성 에이전트 세션은 기존 권한 모드를 유지합니다.',
      chooseTitle: '재개된 에이전트가 권한을 요청하는 방식을 선택하세요.',
    },
    inspector: {
      runDetailsLabel: '실행 세부 정보',
      identityAndSource: '요청자 및 실행 출처',
      requestedBy: '요청자',
      accountableTo: '책임자',
      triggeredFrom: '트리거 소스',
      executedFor: '실행 대상',
      project: '프로젝트',
      repository: '저장소',
      dispatchSnapshot: '디스패치 시점 스냅샷',
      writtenBackAs: '기록 ID',
      externalActor: '외부 ID',
      ruleOwner: '규칙 소유자',
      botOrApp: 'Bot / 앱',
      notAttributed: '귀속되지 않음',
      notApplicable: '해당 없음',
      technicalIdentity: '기술 실행 정보',
      runtimePrincipal: '런타임',
      attribution: '귀속',
      source: '소스',
      precisionExact: '정확',
      precisionLinkedExternal: '외부 ID 연결',
      precisionRuleOwner: '규칙 소유자에게 귀속',
      precisionUnattributed: '귀속되지 않음',
      runOverview: '실행 개요',
      service: '서비스',
      unavailable: '사용 불가',
      trigger: '트리거',
      notReported: '보고되지 않음',
      permission: '권한',
      askBeforeActions: '작업 전 확인',
      workspace: '워크스페이스',
      changes: '변경 사항',
      noCodeChanges: '코드 변경 없음',
      reviewPatch: '전체 패치 검토',
      loadingChangeSummary: '변경 요약 불러오는 중…',
      diffUnavailable: 'diff 사용 불가',
      diffAfterAgent: '에이전트가 diff를 생성한 후 사용 가능',
      viewCompleteDiff: '전체 diff 보기',
      openPrDetails: '풀 리퀘스트 세부 정보 열기',
      draftPr: '초안 PR',
	  executionStatus: '실행 상태',
	  deliveryStatus: '전달 상태',
	  deliveryKind: '전달 대상',
	  deliveryIssue: '전달 문제',
	  deliveryUnknown: '보고되지 않음',
	  delivery: { not_required: '필요 없음', pending: '대기 중', delivered: '전달됨', failed: '실패' },
	  deliveryKindLabel: { artifact: '아티팩트', pull_request: '풀 리퀘스트', branch_update: '브랜치 업데이트', review_comment: '리뷰 댓글' },
      execution: '실행',
      started: '시작됨',
      notStarted: '시작 안 됨',
      duration: '소요 시간',
      runId: '실행 ID',
      retryOf: '재시도 대상',
      resumedFrom: '재개 대상',
      resumedFromLink: '{id}에서 재개됨',
    },
    origin: {
      fromPrComment: 'PR 댓글에서',
      scheduled: '예약됨',
      kanbanAutomation: '칸반 자동화',
      prEventAutomation: 'PR 이벤트 자동화',
    },
    diff: {
      runFailedNoDiff: '이 실행이 실패하여 diff가 생성되지 않았습니다.',
      diffAfterArtifact: 'diff는 에이전트가 아티팩트를 생성한 후 사용할 수 있습니다.',
      noCodeChanges: '이 실행은 코드를 변경하지 않았습니다.',
      loadingDiff: 'diff 불러오는 중…',
      loadDiffError: 'diff를 불러올 수 없습니다',
    },
    failedSubmission: {
      notSent: '메시지가 전송되지 않았습니다.',
      draftPreserved: '초안이 보존되었습니다.',
      retryUnsent: '전송되지 않은 메시지 재시도',
    },
  },
};
